Lyte.Component.register("lyte-editor", {
	data: function () {
		return {
			//ignorei18n_start
			// exposed variables
			ltPropValue: Lyte.attr('string', { default: '' }),
			ltPropLanguage: Lyte.attr('string', { default: 'plaintext' }),
			ltPropOptions: Lyte.attr('object', { default: {} }),
			ltPropBasePath: Lyte.attr('string', { default: '' }), 
			ltPropToolbar: Lyte.attr('array'),//No I18n
			// ltPropToolbarYield: Lyte.attr('boolean', { default: false }),
			ltPropResourceLinks: Lyte.attr('array', { default: [] }),
			ltPropDefaultValue: Lyte.attr('string'),
			ltPropLoadOnDemand: Lyte.attr('object', {
				default: {
					[Lyte.Editor.EDITOR_TYPES.BASIC_EDITOR]: false,
					[Lyte.Editor.EDITOR_TYPES.DIFF_EDITOR]: false
				}
			}),
			ltPropCustomCssPath: Lyte.attr('string'),
			ltPropResourceStrings: Lyte.attr('array', { default: [] }),
			ltPropCompilerOptions: Lyte.attr('object', { default: {} }),
			ltPropCdnLink: Lyte.attr('string', { default: '' }),
			ltPropBaseCssAdded: Lyte.attr('boolean', { default: false }),
			ltPropRenderInShadowRoot: Lyte.attr('boolean', { default: false }), //No I18n
			ize: Lyte.attr('boolean', { default: false }),//No I18n
			ltPropColorizeOptions: Lyte.attr('object', { default: {} }),//No I18n
			ltPropListenForMarkingsChange: Lyte.attr('boolean', { default: false }),//No I18n
			ltPropI18nLanguage: Lyte.attr('string'),//No I18n
			ltPropEditorType: Lyte.attr('string', { default: Lyte.Editor.EDITOR_TYPES.BASIC_EDITOR }),
			ltPropDiffEditorToolbar: Lyte.attr('array'),//No I18n
			ltPropDiffEditorOptions: Lyte.attr('object', { default: {} }),
			ltPropOriginalDiffModel: Lyte.attr('object'),
			ltPropModifiedDiffModel: Lyte.attr('object'),
			ltPropRenderScopedToolbar: Lyte.attr('boolean', { default: true }),
			ltPropHideReadOnlyPrompt: Lyte.attr('boolean', { default: false }),
			ltPropHideCursor : Lyte.attr('boolean', { default : false } ),
			ltPropPlaceholder : Lyte.attr( 'string' ),
			ltPropSingleLineEditor : Lyte.attr( "boolean" ),
			ltPropFileExplorerData: Lyte.attr("array"),
			ltPropRestrictMenu : Lyte.attr("array",{default:[]}),
      		ltPropShowLeftPanel: Lyte.attr("boolean", { default: false }),
			ltPropFingerPrintMapping : Lyte.attr( "object"),
			ltPropFingerPrintPath : Lyte.attr( "string"),
			ltPropDebounce : Lyte.attr( "number", { default : 100 } ),
			ltPropHiddenState : Lyte.attr("boolean"),
			ltPropFileFormat : Lyte.attr("string", { default : "text/javascript,text/html,text/css,.html,.js,.css"}),
			ltPropCustomMonacoFile : Lyte.attr("string"),
			ltPropPreventUndoRedo : Lyte.attr("object"),
			// internal variables
			_id: Lyte.attr('string'),
			editorInstance: Lyte.attr('object'),
			diffEditorInstance: Lyte.attr('object'),
			diffNavigatorInstance: Lyte.attr('object'),
			hasYieldedToolbar: Lyte.attr('boolean', { default: false }),
			current: Lyte.attr('object'),
			editorHtmlPath: Lyte.attr('string', { default: '' }),
			editorHtmlSrcDoc : Lyte.attr( 'string'),
			monaco: Lyte.attr('object', { default: {} }),
			originalDiffModel: Lyte.attr('object'),
			modifiedDiffModel: Lyte.attr('object'),
			hasToolbarData: Lyte.attr('boolean', { default: false }),
			providedToolbarData: Lyte.attr('array'),
			currentToolbarData: Lyte.attr('object', { default: {} }),
			basicToolbarState: Lyte.attr('object', { default: {} }),
			diffToolbarState: Lyte.attr('object', { default: {} }),
			modifiedDiffEditorInstance: Lyte.attr('object'),
			originalDiffEditorInstance: Lyte.attr('object'),
			_loadBasicEditorTriggered: Lyte.attr('boolean', { default: false }),
			_loadDiffEditorTriggered: Lyte.attr('boolean', { default: false }),
			basicEditorOptionsToUpdate: Lyte.attr('object', { default: {} }),
			diffEditorOptionsToUpdate: Lyte.attr('object', { default: {} }),
			toolsInstance: Lyte.attr('object', { default: {} }),
			connectedToolbar: Lyte.attr('object'),
			connectedLayout: Lyte.attr('object'),
			valueLoadedFromModel: Lyte.attr('boolean', { default: false }),
			tbActiveItem : Lyte.attr('string',{default:''}),
			ltPropLeftPanelConfig : Lyte.attr('object'),
			leftPanelDisplay : Lyte.attr('boolean',{
				default : true
			}),
			media :Lyte.attr("object"),
			hideEditor: Lyte.attr("boolean", { default: true }),
			tbActiveItem : Lyte.attr("string",{default:""}),
			additionalConfig : Lyte.attr( "object" , {
				default : { 'GLOBAL_TAGS' : [ 'svg' , 'style', 'path', 'rect', 'polyline', "circle", "polygon", "line", "g"] , 'GLOBAL_ATTRIBUTES' : [ 'x', 'y', 'd', 'cx', 'cy', 'r', "height", "width", "points", "transform", "type"  ] }
			})
			//ignorei18n_end
		}
	},
	init: function () {
		this.pubsub = window["common-utils"].pubsub();
		if (!this.data.ltPropBasePath && _led.basePath) {
			this.setData('ltPropBasePath', _led.basePath);
		}
		let basePath = this.data.ltPropBasePath || _led.basePath;
		_led.initializeGlobalPaths(basePath, this.data.ltPropCdnLink, this.data.ltPropFingerPrintMapping, this.data.ltPropFingerPrintPath );
		if (basePath) {
			if (!this.data.ltPropBaseCssAdded) {
				_led.loadBaseCss();
			}
		} else {
			_led.throw.error(_led.error.INVALID_BASE_PATH, basePath);
		}
		this.setData('toolsInstance', _led.tools()); //No I18n
		this.setData('editorHtmlPath', _led.pathFor.iframeEditor.html);//No I18n
		this.setData( 'editorHtmlSrcDoc', `<!DOCTYPE html>
					<html lang="en">
					
					<head>
					<meta charset="UTF-8">
					<meta name="viewport"
							content="width=device-width, initial-scale=1.0">
					<style>
						.lyteEditorPlaceholder{
						display: none;
						position: absolute;
							top: 0;
							pointer-events: none;
							z-index: 1001;
							opacity: 0.7;
						}
					</style>
					</head>
					
					<body class="lyteEditor">
					<div class="lyteEditorPlaceholder"></div>
					<div class="basicEditor"></div>
					<div class="diffEditor"></div>
					</body>
					
					</html>
			`);
		this.setData('_id', _led.getId());
		_led.setInstance( this.data._id, this );
		// this.triggerMethod('onBeforeLoad', this);
		this.throwCustomEvent('before-load', this);//No I18n -> Non Lyte Application
		// this.throwEvent('beforeload', this);// ! Deprecated @2.0.0
		const providedToolbarData = this.basedOnTypeGet('providedToolbarData');//No I18n
		this.setData({
			providedToolbarData: [].concat(providedToolbarData) || [],
			hasToolbarData: !!providedToolbarData,
			hasYieldedToolbar: !!this.$node.querySelector('template[yield-name="toolbar"]')//No I18n
		});
		this.generateCurrentOptions();
		if (!this.argsCache) {
			this.argsCache = {};
		}
		if (!this.disposables) {
			this.disposables = {};
		}
		this.argsCache[this.data._id] = _led.createArgsCache();
		this.disposables[this.data._id] = _led.createDisposablesHandler();
		
		
		if(!this.data.ltPropShowLeftPanel) {
			this.setData("hideEditor", false);
		}
		this.setData("sanitizer", Lyte.Security.createSanitizer({
			"GLOBAL_TAGS" : [ 'svg' , 'style', 'path', 'rect', 'polyline', "circle", "polygon", "line", "g"],
			"GLOBAL_ATTRIBUTES" : [ 'x', 'y', 'd', 'cx', 'cy', 'r', "height", "width", "points", "transform", "type"  ],
			"FORBID_TAGS" : ["script"],
			"FORBID_ATTR" : [],
			"REMOVE_ONEVENTS" : true,
			"ALLOW_ARIA_ATTR" : true,
			"ALLOWED_STYLE" : "ALL" ,
			"STYLE_VALIDATION" : false,
			"ADD_URI_SAFE_ATTR" : [ ]
		}))
	},
	connectWith: function (object) {
		for (let key in object) {
			const node = object[key];
			switch (key) {
				case 'toolbar': {
					this.setData('connectedToolbar', node);//No I18n
				}
					break;
				case 'layout': {
					this.setData('connectedLayout', node);//No I18n
				}
			}
		}
	},
	initializeLeftPanel : function(){
		this.directory = _led.directory();
			this.folder = _led.folder();
			this.directory.setEditorInstance(this);
			this.folder.setEditorInstance(this);
			if(this.data.ltPropFileExplorerData ){
				this.folder.userDirectory(this.data.ltPropFileExplorerData);
				const id = '_id'; //No I18n
				const item = 'directoryPanelItem'; //No I18n
				 const editorInstance = _led.getInstance(this.getData(id));
				this.setData(item,editorInstance.directory.getDirectoryList())
			}
	},
	/**
	 * This will dispatch custom event to the parent
	 * @param {String} eventName Event to Trigger
	 * @param {array} args Arguments to send
	 */
	throwCustomEvent: function (eventName, args) {
		const config = {
			bubbles: false,
			cancelable: false
		}
		const customEvent = new Event(eventName, config);
		customEvent.arguments = args;
		this.$node.dispatchEvent(customEvent);
	},
	/**
	 * This adds `activeEditor` class to the node
	 * @param {HTMLElement} nodeToQuery Node where monaco editor is created
	 */
	activateEditorBasedOnType: function (nodeToQuery) {
		const classToMakeActive = this.data.ltPropEditorType;
		const activeClass = 'activeEditor';//No I18n
		const alreadyActiveNode = nodeToQuery.querySelector('.' + activeClass)
		const isSameNodeAlreadyActive = alreadyActiveNode ? alreadyActiveNode.classList.contains(classToMakeActive) : false;
		if (!isSameNodeAlreadyActive) {
			if (alreadyActiveNode) {
				alreadyActiveNode.classList.remove(activeClass);
			}
			nodeToQuery.querySelector('.' + classToMakeActive).classList.add(activeClass);//No I18n
		}
	},
	/**
	 * This will extract the necessary information from the options
	 * for showing it in the toolbar and save it in a variable
	 */
	generateCurrentOptions: function () {
		const options = this.data.ltPropOptions || {};
		const diffOptions = this.data.ltPropDiffEditorOptions || {};
		const generateStateFrom = function (opts) {
			const state = {};
			if (opts.hasOwnProperty('theme')) {
				if (opts.theme !== _led.DARK_THEME && opts.theme !== _led.LIGHT_THEME) {
					const ltPropToolbar = this.data.ltPropToolbar;
					const ltPropDiffEditorToolbar = this.data.ltPropDiffEditorToolbar;
					if (ltPropToolbar || ltPropDiffEditorToolbar) {
						_led.updateEnum('LIGHT_THEME', opts.theme);//No I18n
					}
				}
				state.theme = opts.theme;
			}
			return Object.assign(state, {
				fontSize: opts.fontSize,
				toggleWrap: opts.wordWrap,
				formatOnType: opts.formatOnType
			});
		}
		this.setData('basicToolbarState', generateStateFrom.call(this, options));//No I18n
		this.setData('diffToolbarState', generateStateFrom.call(this, diffOptions));//No I18n
	},
	/**
	 * This function will override options and creates a complete set of options to set
	 * @param {Object} options Options to Override
	 * @returns Object
	 */
	overrideOptionsWith: function (options) {
		const editorType = this.data.ltPropEditorType;
		const defaultOptions = _led.EDITOR_OPTIONS[editorType];
		const filteredOptions = Object.assign({}, defaultOptions, options);
		const customOptions = _led._customOptions[editorType];
		customOptions.forEach(function (opt) {
			delete filteredOptions[opt];
		})
		return filteredOptions;
	},
	/**
	 * This function will get called whenever toolbar is initialized
	 * and the current toolbar state is updated by triggering the respective actions
	 */
	applyCurrentToolbarData: function () {
		const toolbar = this.data.connectedToolbar || this.$node.querySelector('lyte-editor-toolbar');
		if( toolbar ){
			const current = this.basedOnTypeGet('toolbarState');//No I18n
			this.setData('currentToolbarData', current);//No I18n
			for (let key in current) {
				this.$node.triggerAction(key, current[key]);
			}
		}
	},
	/**
	 * Updates the compiler options for languages
	 * @param {Object} monaco Global Monaco Instance
	 * @param {Object} compilerOptions Options to set
	 */
	setCompilerOptions: function (monaco, compilerOptions) {
		for (let language in compilerOptions) {
			_led.setCompilerOptionsFor(monaco, language, compilerOptions[language]);
		}
	},
	/**
	 * This will execute the plugins if it is registered in the window
	 * @param {Object} monaco Global Monaco Instance
	 * @param {Object} instance Editor Instance
	 */
	includePlugins: function (monaco, instance) {
		const data = this.data;
		const pluginArgMap = {
			includeDocumentFormatter: [monaco],
			includeDocumentValidator: [monaco, instance, data],
			includeLangConfig: [monaco]
		}
		for (let plugin in pluginArgMap) {
			if (_led[plugin]) {
				_led[plugin].apply(_led, pluginArgMap[plugin])
			}
		}
	},
	/**
	 * This will alter the markings object structure
	 * @param {Object} monaco Global Monaco Instance
	 * @param {Object} marking Markings Object from monaco
	 * @returns Object
	 */
	modifyMarkingsObject: function (monaco, marking) {
		return {
			range: {
				startColumn: marking.startColumn,
				endColumn: marking.endColumn,
				startLineNumber: marking.startLineNumber,
				endLineNumber: marking.endLineNumber
			},
			severity: monaco.MarkerSeverity[marking.severity],
			message: marking.message,
			code : marking.code
		};
	},
	/**
	 * This function will create functions which can be used 
	 * to construct Layout info on request basis
	 * This can be read by user using ltPropBasicEditorInfo | ltPropDiffEditorInfo
	 * @param {Object} instance Editor Instance
	 * @param {String} editorType Current Editor Type ( Basic | Diff)
	 */
	constructLayoutInfo: function (instance, editorType) {
		// - This can be increased in future
		const propGetterFuncMap = {
			//ignorei18n_start
			scrollHeight: 'getScrollHeight',
			editorLayoutInfo: 'getLayoutInfo',
			scrollLeft: 'getScrollLeft',
			scrollTop: 'getScrollTop'
			//ignorei18n_end
		}
		const definedProps = {};
		const baseKey = 'ltProp' + _led.changeCase.toPascal(editorType) + 'Info';//No I18n
		const object = {};
		if (this.data.hasOwnProperty(baseKey)) {
			delete this.data[baseKey];
		}
		Object.defineProperty(this.data, baseKey, {
			get: function () {
				return object;
			},
			set: _led.error.READ_ONLY.bind(_led, baseKey)
		});
		for (let propName in propGetterFuncMap) {
			definedProps[propName] = {
				get: (instance[propGetterFuncMap[propName]]).bind(instance),
				set: _led.error.READ_ONLY.bind(_led, propName)
			}
		}
		Object.defineProperties(object, definedProps);
	},
	/**
	 * This will load the custom css based on whether the 
	 * editor is loaded in the shadow root / iframe
	 * @param {String} customCssPath Css Path from the user
	 */
	loadCustomCssToDoc: function (customCssPath) {
		if (this.data.ltPropRenderInShadowRoot) {
			const editorWrapper = this.$node.querySelector('#' + this.data._id);
			for (let i = 0, len = editorWrapper.childElementCount; i < len; i++) {
				const childNode = editorWrapper.children[i];
				const shadowDocFrag = childNode.shadowRoot;
				if (shadowDocFrag) {
					_led.loadCustomCss(customCssPath, document, shadowDocFrag);
				}
			}
		} else {
			const iframe = this.$node.querySelector('#' + this.data._id);
			const iframeDoc = iframe.contentDocument;
			_led.loadCustomCss(customCssPath, iframeDoc);
		}
	},
	/**
	 * This class when added will not show the blue color `read-only` prompt 
	 * while typing in the read-only editor
	 * @param {HTMLElement} editorDiv Div where editor is loaded
	 * @param {Boolean} isReadOnly whether to show the prompt or not
	 */
	handleReadOnlyEditors: function (editorDiv, isReadOnly, isOriginalReadOnly) {
		const hideReadOnlyPrompt = this.data.ltPropHideReadOnlyPrompt;
		if (hideReadOnlyPrompt) {
			const toggleClass = 'lyte-readonly-editor';//No I18n
			const originalClass = 'lyte-readonly-original-editor';
			if (isReadOnly) {
				editorDiv.classList.add(toggleClass);
			} else {
				editorDiv.classList.remove(toggleClass);
			}
			if( isOriginalReadOnly === true ){
				editorDiv.classList.remove(originalClass);
			}else{
				editorDiv.classList.add(originalClass);
			}
		}
	},
	/**
	 * This will initialize all necessary functions and load the basic
	 * editor in the provided editorDiv
	 * @param {Object} monaco Global Monaco Instance
	 * @param {HTMLElement} editorDiv Div in which editor is created
	 * @param {Object} options Options for Monaco Editor Instance
	 */
	loadBasicEditor: function (monaco, editorDiv, options) {
    this.triggerMethod("onBeforeLoad", this, monaco);
		const disposables = this.disposables[this.data._id];
		const editorInstance = monaco.editor.create(editorDiv, options);
		const editorType = Lyte.Editor.EDITOR_TYPES.BASIC_EDITOR;
		this.setData('editorInstance', editorInstance);
		this.handleReadOnlyEditors(editorDiv, options.readOnly || false);
		this.applyCurrentToolbarData();
		this.$node.editorActions._extendAllCallbacks(monaco, editorInstance, editorType);
		// this.throwEvent('after-basic-editor-load', this, monaco, editorInstance);// ! Deprecated @2.0.0
		// this.throwCustomEvent('onBasicEditorLoad', this, monaco, editorInstance);// ! Deprecated @2.0.0
		this.includePlugins(monaco, editorInstance);
		this.constructLayoutInfo(editorInstance, editorType);
		disposables.add(editorInstance.onDidChangeModelContent(function (obj) {
			const model = editorInstance.getModel();
			const changedValue = model.getValue();
			if (!model._isLyteRestrictedModel) {
				setTimeout( function(){
					this.preventObserverLooping = true;
					this.setData('ltPropValue', changedValue);//No I18n
					this.preventObserverLooping = false;
				}.bind(this),0);
				this.triggerMethod('onValueChange', obj, changedValue);//No I18n
				if( this.data.ltPropShowLeftPanel ){
					this.changeFileContent( editorInstance, changedValue );
				}
			} else if (model._isRestrictedValueValid) {
				setTimeout( function(){
					this.preventObserverLooping = true;
					this.setData('ltPropValue', changedValue);//No I18n
					this.preventObserverLooping = false;
				}.bind(this),0);
				const currentRanges = model.getCurrentEditableRanges();
				this.triggerMethod('onValueChange', obj, changedValue, currentRanges);//No I18n
				if( this.data.ltPropShowLeftPanel ){
					this.changeFileContent( editorInstance, changedValue );
				}
			}
			// if(this.data.ltPropRenderInShadowRoot){
			// 	this.addErrorDecoration(editorInstance,monaco.editor.getModelMarkers(model.id))
			// }
		}.bind(this)));
		let themeChanged = false;
		disposables.add(editorInstance._themeService.onDidColorThemeChange(function (info) {
			themeChanged = true;
			const lyteEditorNode = this.$node;
			const toolName = 'toggleDarkMode';//No I18n
			const data = this.data || {};
			const dataOptions = this.data.ltPropOptions || {};
			const scopedToolbar = lyteEditorNode ? lyteEditorNode.querySelector('lyte-editor-toolbar') : null;//No I18n
			const toolbar = data.connectedToolbar || scopedToolbar;
			if (toolbar) {
				const infoOfThemeTool = toolbar.getInfoOfTool(toolName);
				if (infoOfThemeTool && !infoOfThemeTool.throwEvent) {
					const themeName = info.themeName;
					const actualValue = themeName === _led.DARK_THEME
					if (infoOfThemeTool.current !== actualValue) {
						Lyte.Component.set(infoOfThemeTool, 'current', actualValue);//No I18n
					}
				}
			}
			Lyte.Component.set(dataOptions, 'theme', info.themeName);//No I18n
			this.triggerMethod('onOptionsUpdate', { theme: info.themeName }, dataOptions);//No I18n
		}.bind(this)));
		disposables.add(editorInstance.onDidChangeConfiguration(function (monaco, editorDiv, instance, editorOptions) {
			const options = this.data.basicEditorOptionsToUpdate;
			const dataOptions = this.data.ltPropOptions || {};
			const EditorOption = monaco.editor.EditorOption;
			const actuallyUpdatedOptions = {};
			for (let key in options) {
				if (editorOptions.hasChanged(EditorOption[key])) {
					const value = options[key];
					actuallyUpdatedOptions[key] = value;
					Lyte.Component.set(dataOptions, key, value);
				}
			}
			if (actuallyUpdatedOptions.hasOwnProperty('readOnly')) {
				const readOnly = instance.getOption(EditorOption.readOnly);
				this.handleReadOnlyEditors(editorDiv, readOnly);
			}
			if (Object.keys(actuallyUpdatedOptions).length > 0) {
				this.triggerMethod('onOptionsUpdate', actuallyUpdatedOptions, dataOptions);
			}
		}.bind(this, monaco, editorDiv, editorInstance)));
		
		const listenForMarkingsChange = this.data.ltPropListenForMarkingsChange;
		// if (this.data.ltPropRenderInShadowRoot) {
		// 				var contentWidget = {
		// 					domNode: (function () {
		// 						var domNode = document.createElement("div");
		// 						domNode.classList.add("error_contWidget")
		// 						domNode.classList.add("displayNone");
		// 						return domNode;
		// 					})(),
		// 					position : {},
		// 					getId: function () {
		// 						return "my.content.widget";
		// 					},
		// 					setText : function(txt){
		// 						this.domNode.innerHTML = txt;
		// 					},
		// 					getDomNode: function () {
		// 						return this.domNode;
		// 					},
		// 					displayDom : function(display){
			
		// 						if(display){
		// 							this.domNode.classList.remove("displayNone");
		// 							this.domNode.classList.add("displayBlock");
									
		// 						}
		// 						else{
		// 							this.domNode.classList.remove("displayBlock");
		// 							this.domNode.classList.add("displayNone");
		// 						}
		// 					},
		// 					setPosition : function(position){
		// 						this.position.lineNumber = position.lineNumber;
		// 						this.position.column = position.column;
		// 					},
		// 					getPosition: function () {
		// 						return {
		// 							position: this.position,
		// 							preference: [
		// 								monaco.editor.ContentWidgetPositionPreference.BELOW,
		// 								monaco.editor.ContentWidgetPositionPreference.LEFT,
		// 								monaco.editor.ContentWidgetPositionPreference.RIGHT,
		// 								monaco.editor.ContentWidgetPositionPreference.ABOVE,
										
		// 							],
		// 						};
		// 					},
		// 					destroy : function(){
		// 						this.domNode.remove();
		// 					}
		// 		};
		// 		const mouseHandler = function(e,callback){
		// 					const model = editorInstance.getModel();
		// 					const errorMarkers = monaco.editor.getModelMarkers(model.id);
		// 					if(errorMarkers && errorMarkers.length>0){
		// 						const matchedError = errorMarkers.find(callback)
		// 						if(matchedError==undefined){
		// 							contentWidget.displayDom(false);
		// 							clearWidgetData();
		// 						}
		// 				}
		// 				else{
		// 					contentWidget.displayDom(false);
		// 					clearWidgetData();
		// 				}

		// 				}

		// 			// editorInstance.addContentWidget(contentWidget);
		// 			function clearWidgetData(avoid){
		// 				clearTimeout(contentWidget.$widgetDebounceTimer);
		// 				contentWidget.$widgetDebounceTimer = undefined;
		// 				avoid!=false && contentWidget.setText('');
		// 			}
		// 			editorInstance.onMouseMove (function(e){
		// 					const target = e.target;
		// 					if(!contentWidget._loaded){
		// 						editorInstance.addContentWidget(contentWidget);
		// 						contentWidget._loaded = true;
		// 					}
		// 					if(contentWidget.$widgetDebounceTimer){
		// 						clearWidgetData(false);
		// 					}
		// 					mouseHandler(e,function(eachErrorMark){
		// 							const {startLineNumber,startColumn,endLineNumber,endColumn} = eachErrorMark;
		// 							if(target.range && eachErrorMark.severity == 8){
		// 								const targetElement = target.element;
		// 								const {startLineNumber:targetStartLine,startColumn:targetStartCol,endLineNumber:targetEndLine,endColumn : targetEndCol} = target.range;
		// 							if(startLineNumber == targetStartLine && endLineNumber == targetEndLine && startColumn<=targetStartCol && endColumn>=targetEndCol && targetElement.classList.contains('errorAnnotation')){
		// 									//handle widget
		// 									const widgetDebounceTimer = setTimeout(function(){
		// 										const message = eachErrorMark.message;
		// 									contentWidget.setText(message);
		// 									contentWidget.setPosition({
		// 										lineNumber : endLineNumber,
		// 										column : targetStartCol + 1
		// 									})
		// 									editorInstance.layoutContentWidget(contentWidget);
		// 									contentWidget.displayDom(true);
		// 									clearWidgetData(false);
		// 									},200);
		// 									contentWidget.$widgetDebounceTimer = widgetDebounceTimer;
		// 									return true;

		// 							}
		// 						}
		// 							return false;
		// 					})
		// 				});
		// 	disposables.add({
		// 	dispose : function(){
		// 			editorInstance.removeContentWidget(contentWidget);
		// 	}
		// 	})
		// 	disposables.add(editorInstance.onDidChangeModel(function(obj){
		// 		if(obj.newModelUrl) {
		// 			this.addErrorDecoration(editorInstance,monaco.editor.getModelMarkers(editorInstance.getModel().id));
		// 		}
		// 	}.bind(this)))
		// }
		if (listenForMarkingsChange ||  this.data.ltPropRenderInShadowRoot) {
			disposables.add(monaco.editor.onDidChangeMarkers(function () {
				const model = editorInstance.getModel();
				const markings = monaco.editor.getModelMarkers(model.id);
				//get editor based on type
				const editor = this.data.editorInstance;
				if(this.data.ltPropRenderInShadowRoot){
					this.addErrorDecoration(editor,markings);
				}
				listenForMarkingsChange && this.triggerMethod('onMarkingsChange', markings.map(this.modifyMarkingsObject.bind(this, monaco)));//No I18n
			}.bind(this)));
		}
		this.triggerMethod('onBasicEditorLoad', this, monaco, editorInstance);//No I18n
	},
	/**
	 * This will load the diff editor in the editorDiv
	 * @param {Object} monaco Global Monaco Instance
	 * @param {HTMLElement} editorDiv Div in which editor is created
	 * @param {Object} options Options for Monaco Editor Instance
	 */
	loadDiffEditor: function (monaco, editorDiv, options) {
		this.triggerMethod("onBeforeLoad", this, monaco);
		const disposables = this.disposables[this.data._id];
		const diffEditorInstance = monaco.editor.createDiffEditor(editorDiv, options);
		const editorType = Lyte.Editor.EDITOR_TYPES.DIFF_EDITOR;
		this.setData('diffEditorInstance', diffEditorInstance);//No I18n
		this.handleReadOnlyEditors(editorDiv, options.readOnly || false, options.originalEditable );
		let originalModel = this.data.originalDiffModel;
		let modifiedModel = this.data.modifiedDiffModel;
		if (!originalModel) {
			this.updateDiffModel({
				modelDef: this.data.ltPropOriginalDiffModel,
				dataName: 'originalDiffModel'//No I18n
			});
		}
		if (!modifiedModel) {
			this.updateDiffModel({
				modelDef: this.data.ltPropModifiedDiffModel,
				dataName: 'modifiedDiffModel'//No I18n
			});
		}
		this.loadDiffModelToInstance();
		this.applyCurrentToolbarData();
		const modifiedDiffEditorInstance = diffEditorInstance.getModifiedEditor();
		const originalDiffEditorInstance = diffEditorInstance.getOriginalEditor();
		this.includePlugins(monaco, modifiedDiffEditorInstance);
		this.constructLayoutInfo(modifiedDiffEditorInstance, Lyte.Editor.EDITOR_TYPES.DIFF_EDITOR);
		this.$node.editorActions._extendAllCallbacks(monaco, diffEditorInstance, editorType);
		// this.throwEvent('after-diff-editor-load', this, monaco, editorInstance);// ! Deprecated @2.0.0
		// this.throwCustomEvent('onDiffEditorLoad', this, monaco, editorInstance);
		// diffEditorInstance.onDidUpdateDiff(function () {
		// 	this.preventObserverLooping = true;
		// 	const models = diffEditorInstance.getModel();
		// 	const valuesOfModels = {};
		// 	for (let key in models) {
		// 		const model = models[key];
		// 		valuesOfModels[key] = model.getValue();
		// 	}
		// 	this.setData('ltPropModifiedDiffModel.value', valuesOfModels.modified);
		// 	this.setData('ltPropOriginalDiffModel.value', valuesOfModels.original);
		// 	this.triggerMethod('onDiffEditorValueChange', valuesOfModels);
		// }.bind(this));

		disposables.add(modifiedDiffEditorInstance.onDidChangeModelContent(function (obj) {
			const model = modifiedDiffEditorInstance.getModel();
			const modifiedValue = modifiedDiffEditorInstance.getValue();
			if (!model._isLyteRestrictedModel) {
				setTimeout( function(){
					this.preventObserverLooping = true;
					this.data.ltPropModifiedDiffModel && this.setData('ltPropModifiedDiffModel.value', modifiedValue);//No I18n
					this.preventObserverLooping = false;
				}.bind(this),0);
				this.triggerMethod('onModifiedDiffModelValueChange', obj, modifiedValue);//No I18n
			} else if (model._isRestrictedValueValid) {
				// this.preventObserverLooping = true;
				setTimeout( function(){
					this.preventObserverLooping = true;
					this.data.ltPropModifiedDiffModel && this.setData('ltPropModifiedDiffModel.value', modifiedValue);//No I18n
					this.preventObserverLooping = false;
				}.bind(this),0);
				this.triggerMethod('onModifiedDiffModelValueChange', obj, modifiedValue);//No I18n
			}
			if( this.data.ltPropShowLeftPanel ){
				this.changeFileContent( modifiedDiffEditorInstance, modifiedValue );
			}
		}.bind(this)));
		disposables.add(originalDiffEditorInstance.onDidChangeModelContent(function (obj) {
			const originalModelValue = originalDiffEditorInstance.getValue();
			setTimeout( function(){
				this.preventObserverLooping = true;
				this.data.ltPropOriginalDiffModel &&  this.setData('ltPropOriginalDiffModel.value', originalModelValue);//No I18n
				this.preventObserverLooping = false;
			}.bind(this),0);
			this.triggerMethod('onOriginalDiffModelValueChange', obj, originalModelValue);//No I18n
			if( this.data.ltPropShowLeftPanel ){
					this.changeFileContent( originalDiffEditorInstance, originalModelValue,true );
				}
		}.bind(this)));

		let themeChanged = false;
		disposables.add(modifiedDiffEditorInstance._themeService.onDidColorThemeChange(function (info) {
			themeChanged = true;
			const lyteEditorNode = this.$node;
			const toolName = 'toggleDarkMode';//No I18n
			const data = this.data || {};
			const dataOptions = this.data.ltPropDiffEditorOptions || {};
			const scopedToolbar = lyteEditorNode ? lyteEditorNode.querySelector('lyte-editor-toolbar') : null;//No I18n
			const toolbar = data.connectedToolbar || scopedToolbar;
			if (toolbar) {
				const infoOfThemeTool = toolbar.getInfoOfTool(toolName);
				if (infoOfThemeTool && !infoOfThemeTool.throwEvent) {
					const themeName = info.themeName;
					const actualValue = themeName === _led.DARK_THEME
					if (infoOfThemeTool.current !== actualValue) {
						Lyte.Component.set(infoOfThemeTool, 'current', actualValue);//No I18n
					}
				}
			}
			Lyte.Component.set(dataOptions, 'theme', info.themeName);//No I18n
			this.triggerMethod('onDiffEditorOptionsUpdate', { theme: info.themeName }, dataOptions);//No I18n
		}.bind(this)));
		disposables.add(modifiedDiffEditorInstance.onDidChangeConfiguration(function (monaco, editorDiv, instance, editorOptions) {
			const options = this.data.diffEditorOptionsToUpdate;
			const dataOptions = this.data.ltPropDiffEditorOptions || {};
			const actuallyUpdatedOptions = {};
			for (let key in options) {
				if (editorOptions.hasChanged(monaco.editor.EditorOption[key])) {
					const value = options[key];
					actuallyUpdatedOptions[key] = value;
					Lyte.Component.set(dataOptions, key, value);
				}
			}
			if (actuallyUpdatedOptions.hasOwnProperty('readOnly')) {
				const readOnly = instance.getOption(monaco.editor.EditorOption.readOnly);
				this.handleReadOnlyEditors(editorDiv, readOnly, actuallyUpdatedOptions.originalEditable);
			}
			this.triggerMethod('onDiffEditorOptionsUpdate', actuallyUpdatedOptions, dataOptions);//No I18n
		}.bind(this, monaco, editorDiv, modifiedDiffEditorInstance)));
		disposables.add(originalDiffEditorInstance.onDidChangeConfiguration(function (monaco, editorDiv, instance, editorOptions) {
			const options = this.data.diffEditorOptionsToUpdate;
			const dataOptions = this.data.ltPropDiffEditorOptions || {};
			const actuallyUpdatedOptions = {
				originalEditable : options.originalEditable
			};
			Lyte.Component.set(dataOptions, 'originalEditable', options.originalEditable );
			this.handleReadOnlyEditors(editorDiv, dataOptions.readOnly || false, options.originalEditable);
			this.triggerMethod('onDiffEditorOptionsUpdate', actuallyUpdatedOptions, dataOptions);//No I18n
		}.bind(this, monaco, editorDiv, originalDiffEditorInstance)));

		this.setData({
			modifiedDiffEditorInstance: modifiedDiffEditorInstance,
			originalDiffEditorInstance: originalDiffEditorInstance
		})
		this.triggerMethod('onDiffEditorLoad', this, monaco, diffEditorInstance);//No I18n
	},
	/**
	 * This will update the value | language of the Diff Model
	 * @param {Object} definition Input to the Diff Model
	 */
	updateDiffModel: function (definition) {
		const monaco = this.data.monaco;
		if (monaco) {
			definition = definition || {};
			const changedKey = definition.changedKey;
			const modelDef = definition.modelDef || {};
			const dataName = definition.dataName;
			const editorType = dataName.includes('modified') ? '_modifiedEditor' : '_originalEditor';
			const value = modelDef.value || '';
			const language = modelDef.language;
			const uri = modelDef.uri;
			const editorInstance = this.data.diffEditorInstance[ editorType ];
			const actualModel = this.data[dataName] || (uri && monaco.editor.getModel(uri)) || monaco.editor.createModel(value, language, uri);
			const editorOptions = this.data.ltPropDiffEditorOptions
			let isReadOnly;
			if( dataName.includes('modified') ){
				isReadOnly = editorOptions.readOnly !== undefined ? editorOptions.readOnly : false;
				if( this.data.ltPropPreventUndoRedo && this.data.ltPropPreventUndoRedo.modified ){
					isReadOnly = true;
					this.data.ltPropPreventUndoRedo.modified = false
				}
			}else{
				isReadOnly = editorOptions.originalEditable !== undefined ? editorOptions.originalEditable : true;
				if( this.data.ltPropPreventUndoRedo && this.data.ltPropPreventUndoRedo.original ){
					isReadOnly = true;
					this.data.ltPropPreventUndoRedo.original = false
				}
			}
			if (changedKey) {
				switch (changedKey) {
					case 'value': {
						if( isReadOnly ){
							actualModel.setValue(modelDef[changedKey]);
						}else{
							editorInstance.pushUndoStop();
							editorInstance.executeEdits('content-changed', [
								{
									range: actualModel.getFullModelRange(),
									text: modelDef[changedKey]
								}
							])
							editorInstance.pushUndoStop()
						}	
					}
						break;
					case 'language': {
						monaco.editor.setModelLanguage(actualModel, modelDef[changedKey]);
					}
						break;
				}
			}
			this.setData(dataName, actualModel);
		}
	},
	/**
	 * As the name suggests, it sets the original and modified
	 * model to the diffEditorInstance
	 */
	loadDiffModelToInstance: function () {
		const diffEditorInstance = this.data.diffEditorInstance;
		const originalDiffModel = this.data.originalDiffModel;
		const modifiedDiffModel = this.data.modifiedDiffModel;
		if (diffEditorInstance && originalDiffModel && modifiedDiffModel) {
			diffEditorInstance.setModel({
				original: originalDiffModel,
				modified: modifiedDiffModel
			});
		}
	},
	/**
	 * As the name suggests, it sets all preloaded values
	 */
	addAllPreloadedValues: function (monaco) {
		// all the api should have an entry here
		_led.addPreloadedThemes(monaco);
	},
	/**
	 * This function is used to find the breaking points in
	 * restricted editor.
	 * For example, if function name is only editable in the below snippet
	 * 
	 * function nameOfFunc(){ ... }
	 * 
	 * then the check points will be 10th column (column where nameOfFunc start)
	 * and 20th column (column where nameOfFunc ends)
	 * 
	 * Restricted editor will perform undo only once in those checkpoints
	 * to ensure proper working of restrictions
	 */
	checkForCheckPointsInModel: function () {
		const editorType = this.data.ltPropEditorType;
		const instanceOfEditor = this.basedOnTypeGet('instanceOfEditor');//No I18n
		if (editorType === _led.EDITOR_TYPES.BASIC_EDITOR) {
			const model = instanceOfEditor.getModel();
			if (model._isCursorAtCheckPoint) {
				const selections = instanceOfEditor.getSelections()
				const positions = selections.map(function (selection) {
					return {
						lineNumber: selection.positionLineNumber,
						column: selection.positionColumn
					}
				});
				model._isCursorAtCheckPoint(positions);
				model._currentCursorPositions = selections;
			}
		}
	},
	/**
	 * Created div in inside shadowRoot and adds necessary css from monaco
	 * @param {Object} data data needed for creation of shadowRoot
	 * @returns HTMLElement
	 */
	initializeShadowRoot: function (data) {
		const className = this.data.ltPropEditorType;
		const selector = '#' + data._id + ' .' + className;//No I18n
		const shadowParent = this.$node.querySelector(selector);
		const shadowRoot = shadowParent.attachShadow({ mode: 'open' }); //No I18n
		const actualPath = _led.pathFor.monaco.baseFolder;
		const editorDiv = document.createElement('div');
		// shadowRoot.appendChild(editorDiv);
		editorDiv.style.width = "100%";//No I18n
		editorDiv.style.height = "100%";//No I18n
		const innerStyle = document.createElement('style');
		const content = [
			//ignorei18n_start
			'@import "' + actualPath + '/editor/editor.main.css";',
			'@import "' + _led.pathFor.editorContextCss + '";',
			`.error_contWidget{
				font-family : 'Menlo, Monaco, "Courier New", monospace';
				font-weight : normal;
				justify-content: center;
    			align-items: center;
				font-size : 16px;
				font-feature-settings : "liga" 0, "calt" 0;
				font-variation-settings : normal;
				line-height : 18px;
				letter-spacing : 0px;
				max-width: 500px;
				max-height: 250px;
				width: 235px;
				height: 30px;
				color : #616161;
    			background-color: #f3f3f3;
    			border-width: 1px;
				 border-style :  solid;
				 border-color :  #c8c8c8;
    			border-radius: 3px;
				padding : 4px 10px;
				z-index : 1;
			} 
				.displayBlock{
					display : flex  !important;
				}
				.displayNone{display : none !important;}`
			//ignorei18n_end
		];
		innerStyle.innerText = content.join('\n');//No I18n
		_led.addFontFaceForShadowRoot(data, document);
		return new Promise( function( resolve, reject){
			innerStyle.addEventListener('load', function(){
				shadowRoot.appendChild(editorDiv);
				resolve(editorDiv);
			})
			shadowRoot.appendChild(innerStyle);
		})
	},
	addErrorDecoration : function(editor,markings){
		const errorAnnotationArr = [];
		this.data.createdDecortion && editor.removeDecorations(this.data.createdDecortion._decorationIds);
		markings.forEach((eachMark)=>{
							errorAnnotationArr.push(
								{
									range: {
										startLineNumber : eachMark.startLineNumber,
										startColumn : eachMark.startColumn,
										endLineNumber : eachMark.endLineNumber,
										endColumn : eachMark.endColumn
									},
									options: {
									isWholeLine: false,
									inlineClassName: "errorAnnotation",
									}
								}
							)
		})
		const createdDecortion = editor.createDecorationsCollection(errorAnnotationArr);
		this.setData('createdDecortion',createdDecortion);
	},
	saveDirectoryFile : function(acitveFile, needKeys) {
		this.directory.saveCurrentFile(acitveFile).then(function(){
			this.triggerMethod("onSave",this.directory.getFileModelObj(acitveFile.uniqueId,needKeys), this );
		}.bind( this ));
	},
	/**
	 * Will start creation of basic editor
	 * @param {HTMLDocument} doc this might be iframe document / current frame document depending on the ltPropRenderInShadowRoot
	 * @param {Object} monaco Global Monaco Instance
	 * @param {Object} data Necessary Data
	 */
	initializeBasicEditorDiv : function( editorDiv, monaco, data ){
		if (!editorDiv._fnToValidateCheckPointsAdded) {
			const listenerFn = this.checkForCheckPointsInModel.bind(this);
			editorDiv.addEventListener('keydown', listenerFn, true);
			editorDiv._fnToValidateCheckPointsAdded = listenerFn;
		}
		const argsCache = this.argsCache[this.data._id];
		const options = this.overrideOptionsWith(data.ltPropOptions);
		const compilerOptions = data.ltPropCompilerOptions || {};
		this.setCompilerOptions(monaco, compilerOptions);
		this.addAllPreloadedValues(monaco);
		options.value = data.ltPropValue || data.ltPropDefaultValue;
		options.language = data.ltPropLanguage;

		argsCache.saveFor('loadBasicEditor', monaco, editorDiv, options);//No I18n
		if (!data.ltPropLoadOnDemand[Lyte.Editor.EDITOR_TYPES.BASIC_EDITOR] || this.data._loadBasicEditorTriggered) {
			argsCache.callFnAndRmCache.call(this, 'loadBasicEditor');//No I18n
			delete this.data._loadBasicEditorTriggered;
		}
	},
	initializeDiffEditorDiv : function( editorDiv, monaco, data ){
		if (!editorDiv._fnToValidateCheckPointsAdded) {
			const listenerFn = this.checkForCheckPointsInModel.bind(this);
			editorDiv.addEventListener('keydown', listenerFn, true);
			editorDiv._fnToValidateCheckPointsAdded = listenerFn;
		}
		const argsCache = this.argsCache[this.data._id];
		const options = this.overrideOptionsWith(data.ltPropDiffEditorOptions);
		const compilerOptions = data.ltPropCompilerOptions || {};
		this.setCompilerOptions(monaco, compilerOptions);
		this.addAllPreloadedValues(monaco);

		argsCache.saveFor('loadDiffEditor', monaco, editorDiv, options);//No I18n
		if (!data.ltPropLoadOnDemand[Lyte.Editor.EDITOR_TYPES.DIFF_EDITOR] || this.data._loadDiffEditorTriggered) {
			argsCache.callFnAndRmCache.call(this, 'loadDiffEditor');//No I18n
			delete this.data._loadDiffEditorTriggered;
		}
	},
	initializePlaceHolder : function(activateOnDidBlur){
		const type = this.data.ltPropEditorType;
		const editorInstance = 
		this.data.ltPropEditorType === Lyte.Editor.EDITOR_TYPES.BASIC_EDITOR
							 ? this.data.editorInstance : this.data.modifiedDiffEditorInstance;
		const nodeToQuery = this.data.ltPropRenderInShadowRoot ? this.$node : $L(editorInstance._domElement).closest('.lyteEditor')[0];
		this._placeholder = nodeToQuery.querySelector( ".lyteEditorPlaceholder" );
		if( this.data.placeHolderNotSetted ){
			this.showPlaceholder( this.data.ltPropValue );
			this.setData( "placeHolderNotSetted", false );
		}
		if( this.data.ltPropPlaceholder && editorInstance ){
			if( !this.data.ltPropRenderInShadowRoot ){
				this._placeholder.innerText = this.data.ltPropPlaceholder;
			}
			const ele =  editorInstance._domElement.querySelector(".monaco-scrollable-element");
			if(this.data.ltPropShowLeftPanel && this.data.ltPropRenderInShadowRoot) {
				this._placeholder.style.top = "40px";
			}
			this._placeholder.style.left = editorInstance._domElement.offsetLeft + ele.offsetLeft + "px";
			if(activateOnDidBlur){
			this.showPlaceholder( editorInstance.getValue() );	
			  editorInstance.onDidBlurEditorWidget( function(){
							const timeout = this.getData('placeHolderTimeout');
							if(timeout){
								clearTimeout(timeout);
							}
							const currTimeout = setTimeout(function(){
							if(this.getData('restrictPlaceHolder') != true){
									let currentInstance;
								if(this.data.ltPropEditorType == Lyte.Editor.EDITOR_TYPES.BASIC_EDITOR){
									currentInstance = this.data.editorInstance;
								}
								else{
									currentInstance = this.data.modifiedDiffEditorInstance;
								}

								this.showPlaceholder( currentInstance.getValue() );
								// if(currentInstance == editorInstance){
									
								// }
						}
						// this.setData('restrictPlaceHolder',false);
						}.bind(this),100);	
						this.setData('placeHolderTimeout',currTimeout);
			}.bind( this ));
		}	
		
		
		}
	},
	initializeEditorActions : function( win ){
		const editorInstance = 
		this.data.ltPropEditorType === Lyte.Editor.EDITOR_TYPES.BASIC_EDITOR
							 ? this.data.editorInstance : this.data.modifiedDiffEditorInstance;
		const nodeToQuery = this.data.ltPropRenderInShadowRoot ? this.$node : $L(editorInstance._domElement).closest('.lyteEditor')[0];
		this.initializePlaceHolder(true);
		if(this.data.ltPropLeftPanelConfig && this.data.ltPropLeftPanelConfig.commandPalette == false){
			editorInstance.addCommand(win.monaco.KeyCode.F1,function(){})
		}
		if( this.data.ltPropSingleLineEditor ){
			editorInstance.addCommand(monaco.KeyMod.CtrlCmd | monaco.KeyCode.KEY_F, function(){})
			editorInstance.addCommand(monaco.KeyCode.Enter, function(){
				const StateOpen = 3
				if ( editorInstance._contentWidgets['editor.widget.suggestWidget'].widget._widget._state === StateOpen ) {
					editorInstance.trigger('', 'acceptSelectedSuggestion');
				} 
			});
			// disable `F1` command palette
			editorInstance.addCommand(monaco.KeyCode.F1, function(){})			
		}
		win.require && win.require(['vs/platform/actions/common/actions'], function( actions ){
			const menus = Array.from( actions.MenuRegistry._menuItems );
			const contextMenuEntry = menus.find(function( entry ){
				return entry[0].id === "EditorContext"
			} )
			const contextMenuLinks = contextMenuEntry[1];
			const removableIds  = [ 
				"editor.action.clipboardCutAction",
				"editor.action.clipboardCopyAction",
				"editor.action.clipboardPasteAction"
			]
			const removeById = ( list, ids ) => {
				let node = list._first
				do {
					let id =  ( node.element && node.element.command && node.element.command.id ) 
						|| ( node.element && node.element.title )
					let shouldRemove = ids.includes( id ) || ids.includes( id );
					if (shouldRemove) { list._remove(node) }
				} while ((node = node.next))
			}
			removeById(contextMenuLinks, removableIds)
		})
		editorInstance.onDidFocusEditorWidget( function(){
			this.triggerMethod( "onFocus", this.$node, editorInstance, this );
			if( this.data.ltPropPlaceholder ){
				this.hidePlaceholder();
			}
		}.bind( this ));
		editorInstance.onDidPaste( function( args ){
			this.triggerMethod( "onPaste", editorInstance.getModel().getValueInRange( args.range), this.$node, editorInstance, this );
			if( this.data.ltPropSingleLineEditor ){
				// multiple rows will be merged to single row
				if ( args.range.endLineNumber <= 1 ) {
					return
				}
				let newContent = ''
				const textModel = editorInstance.getModel()
				const lineCount = textModel.getLineCount()
				// remove all line breaks
				for (let i = 0; i < lineCount; i += 1) {
					newContent += textModel.getLineContent(i + 1)
				}
				textModel.setValue(newContent)
				editorInstance.setPosition({ column: newContent.length + 1, lineNumber: 1 })
			} 
		}.bind( this ));
		if(this.menuAdded) {
			return;
		}
		this.$node.editorActions.add(function (args) {
			const KeyCode = args.KeyCode;
			const KeyMod = args.KeyMod;
			const getBrowser = function(){
				//Check if browser is IE11
				if (window.navigator.userAgent.search("rv:11") >= 0) {
					return "ie";
				}
				//Check if browser is Edge
				if (window.navigator.userAgent.search("Edge") >= 0) {
					return "edge";
				}
				//Check if browser is Chrome || Opera
				else if (window.navigator.userAgent.search("Chrome") >= 0) {
					return "chrome";
				}
				//Check if browser is Firefox
				else if (window.navigator.userAgent.search("Firefox") >= 0) {
					return "firefox";
				}
				//Check if browser is Safari
				else if (window.navigator.userAgent.search("Safari") >= 0 && window.navigator.userAgent.search("Chrome") < 0) {
					return "safari";
				}
			}
			const browser = getBrowser();
			const supportsPaste = (typeof navigator.clipboard === 'undefined' || browser === "firefox" ) ? document.queryCommandSupported('paste') : true;
			//ignorei18n_start
			const actions =  [
				{
					id : "onCut",
					label : " Cut",
					self : this,
					keybindings : [ KeyMod.CtrlCmd | KeyCode.KeyX ],
					precondition : '!findInputFocussed && !replaceInputFocussed',
					run : function( editor ){
						_led.debounce(function () {
							editor.focus();
							this.self.triggerMethod( "onCut", editor.getModel().getValueInRange( editor.getSelection() ), this.self, editor, this.self.$node );
							editor.trigger('source','editor.action.clipboardCutAction');
						}.bind( this ), this.self.data.ltPropDebounce )

					}
				},
				{
					id: "onCopy",
					label: "Copy",
					self : this,
					keybindings: [KeyMod.CtrlCmd | KeyCode.KeyC],
					precondition : '!findInputFocussed && !replaceInputFocussed',
					run: function (editor) {
						_led.debounce(function () {
							editor.focus();
							this.self.triggerMethod( "onCopy", editor.getModel().getValueInRange( editor.getSelection() ), this.self, editor, this.self.$node );
							editor.trigger('source','editor.action.clipboardCopyAction');
						}.bind( this ), this.self.data.ltPropDebounce )
					}
				}
			];
			if( supportsPaste ){
				actions.push( {
					id : "onPaste",
					label : "Paste",
					self : this,
					keybindings : [ KeyMod.CtrlCmd | KeyCode.KeyV ],
					precondition : '!findInputFocussed && !replaceInputFocussed',
					run : function( editor ){
						_led.debounce(function () {
							editor.focus();
							editor.trigger('source','editor.action.clipboardPasteAction');
						}.bind( this ), this.self.data.ltPropDebounce )
					}
				} )
			}
			actions.push( {
				id: "onSave",
				label: "Save",
				self : this,
				keybindings: [KeyMod.CtrlCmd | KeyCode.KeyS],
				run: function (editor) {
					_led.debounce(function () {
						if( this.self.data.ltPropShowLeftPanel ){
							const acitveFile = this.self.directory.getCurrentlyActiveFile();
							const needKeys = ["name","value","lastSavedValue","ext","isDirty","uniqueId"];
							const beforeSaveResult = this.self.triggerMethod('onBeforeSave',this.self.directory.getFileModelObj(acitveFile.uniqueId,needKeys), this.self ); 
							if( beforeSaveResult && beforeSaveResult.then ) {
								beforeSaveResult.then( function(){
									this.self.saveDirectoryFile(acitveFile, needKeys);
								}.bind( this ) )
							}
							else if(beforeSaveResult !== false)
							{
								this.self.saveDirectoryFile(acitveFile, needKeys);
							}
						}else{
							this.self.triggerMethod( "onSave", this.self.data.ltPropValue, this.self, editor, this.self.$node );
						}
					}.bind( this ), this.self.data.ltPropDebounce )
				}
			})
			return actions;
		}.bind(this))
		this.menuAdded = true;
	},
	initializeBasicEditor: function (doc, monaco, data, win ) {
		const customCssPath = data.ltPropCustomCssPath;
		let editorDiv = null;
		const self = this;
		if (this.data.ltPropRenderInShadowRoot) {
			editorDiv = this.initializeShadowRoot(data);
		} else {
			editorDiv = doc.querySelector('.lyteEditor .basicEditor');//No I18n
		}
		if( editorDiv.then ){
			editorDiv.then( function( editor ){
				self.initializeBasicEditorDiv( editor,monaco, data );
				self.initializeEditorActions( win );
			})
		}else{
			this.initializeBasicEditorDiv( editorDiv,monaco, data );
			this.initializeEditorActions( win );
		}
		if (this.data.ltPropDefaultValue === undefined) {
			this.setData('ltPropDefaultValue', this.data.ltPropValue);//No I18n
		}
		if (customCssPath) {
			this.loadCustomCssToDoc(customCssPath);
		}
	},
	/**
	 * Will start creation of diff editor
	 * @param {HTMLDocument} doc this might be iframe document / current frame document depending on the ltPropRenderInShadowRoot
	 * @param {Object} monaco Global Monaco Instance
	 * @param {Object} data Necessary Data
	 */
	initializeDiffEditor: function (doc, monaco, data, win ) {
		const customCssPath = data.ltPropCustomCssPath;
		const self = this;
		let editorDiv = null;
		if (this.data.ltPropRenderInShadowRoot) {
			editorDiv = this.initializeShadowRoot(data);
		} else {
			editorDiv = doc.querySelector('.lyteEditor .diffEditor');//No I18n
		}
		if( editorDiv.then ){
			editorDiv.then( function( editor ){
				self.initializeDiffEditorDiv( editor,monaco, data );
				self.initializeEditorActions( win );
			})
		}else{
			this.initializeDiffEditorDiv( editorDiv, monaco, data );
			this.initializeEditorActions( win );
		}
		if (customCssPath) {
			this.loadCustomCssToDoc(customCssPath);
		}
	},
	/**
	 * Will start creation editor instance 
	 * @param {HTMLDocument} doc this might be iframe document / current frame document depending on the ltPropRenderInShadowRoot
	 * @param {Object} win iframe window | current window - `ltPropRenderInShadowRoot`
	 * @param {Object} monaco Global Monaco Instance
	 */
	initializeEditor: function (doc, win, monaco) {
		this.setData('monaco', monaco);//No I18n
		_led.updateEnum('MONACO_SRC_LOADED', true);//No I18n
		_led.pubsub.fire('MONACO_LOADED', monaco);//No I18n
		this.hasAction( "editor-core-loaded" ) && this.throwEvent('editor-core-loaded');//No I18n
		const data = this.getData();
		const argsCache = this.argsCache[this.data._id];
		win.addEventListener('resize', _led.updateEditorLayout.bind(_led, this));
		if (!data.ltPropRenderInShadowRoot || !_led._listenersAddedToWindow) {
			/**
			 * data.ltPropRenderInShadowRoot => A
			 * _led._listenersAddedToWindow => B
			 * 					
			 * # Case 1 : Rendered in Shadow root
			 * - Add these listener to the window,only if the `addedListener` value is false
			 * - State A - true =>   Output State depends on failure of State B and it will be inverse of State B
			 * 
			 * # Case 2 : Rendered in Iframe
			 * - Add these listener to the window regardless of 2nd state
			 * - State A - false =>   Output State does not depend on State B
			 * 
			 */
			// https://github.com/microsoft/monaco-editor/issues/2382#issuecomment-796741318
			win.addEventListener('unhandledrejection', function (event) {
				if (event.reason && event.reason.name === 'Canceled') {
					// monaco editor promise cancellation
					event.preventDefault();
				}
			});
			if (data.ltPropRenderInShadowRoot) {
				_led._listenersAddedToWindow = true;
			}
		}
		const resourceLinks = data.ltPropResourceLinks || [];
		const resourceStrings = data.ltPropResourceStrings || [];

		_led.refreshAllLibsFrom(monaco, resourceLinks, this);
		resourceStrings.forEach(function (string) {
			_led.addLib(monaco, string);
		});

		argsCache.saveFor('initializeBasicEditor', doc, monaco, data, win );
		argsCache.saveFor('initializeDiffEditor', doc, monaco, data, win );

		if (data.ltPropEditorType === Lyte.Editor.EDITOR_TYPES.BASIC_EDITOR) {
			argsCache.callFn.call(this, 'initializeBasicEditor');//No I18n
		} else if (data.ltPropEditorType === Lyte.Editor.EDITOR_TYPES.DIFF_EDITOR) {
			argsCache.callFn.call(this, 'initializeDiffEditor');//No I18n
		}
	},
	showPlaceholder : function( value ){
		if( !this._placeholder ){
			this.setData( "placeHolderNotSetted", true );
			return
		}
		if( value === "" && this.data.ltPropPlaceholder ){
			this._placeholder.style.display = "initial";
		}else{
			this.hidePlaceholder();
		}
	},
	hidePlaceholder :  function(){
		if( !this._placeholder ){
			this.setData( "placeHolderNotSetted", true );
			return;
		}
		this._placeholder.style.display = "none";
	},
	/**
	 * Wrapper for execute method of Lyte
	 * @param {String} methodName Name of the method to be triggered
	 * @returns *
	 */
	triggerMethod: function (methodName) {
		if (this.getMethods( methodName )) {
			return this.executeMethod.apply(this, Array.from(arguments))
		}
	},
	/**
	 * Adds event listeners to tools
	 * the application team has to provide trigger-action attribute
	 * to properly bind the tool item with proper function
	 */
	addEventListenersToTools: function () {
		const yieldedToolbar = this.$node.querySelector('lyte-yield[yield-name="toolbar"]');
		const toolNodes = yieldedToolbar.querySelectorAll('[trigger-action]');
		const node = this.$node;
		const id = this.data._id;
		toolNodes.forEach(function (toolNode) {
			const actionName = toolNode.getAttribute('trigger-action');
			const listenerFunc = function () {
				const tool = this.data.toolsInstance[actionName];
				if (tool) {
					node.triggerAction(actionName, tool.current, tool);
				}
			}
			_led.holdReferenceOf(toolNode, 'click', listenerFunc, id);
			toolNode.addEventListener('click', listenerFunc, true);
		});
	},
	/**
	 * adds necessary files to the iframe
	 * @param {HTMLElement} iframe 
	 */
	injectSourceFiles: function (iframe) {
		const iframeDoc = iframe.contentDocument;
		const iframeWin = iframe.contentWindow;
		// const data = this.getData();
		// Send the necessary data from here
		iframeWin.infoFromParent = {
			_led: _led,
			editorComp: this
		}
		// if( _led.checkType.isLink(_led.pathFor.iframeEditor.baseFolder) ){
			_led.loadResources( _led.pathFor.iframeEditor.js, iframeDoc );//No I18n
		// }else{
		// 	_led.loadResources(_led.path.relative(_led.pathFor.iframeEditor.baseFolder, _led.pathFor.iframeEditor.js), iframeDoc);//No I18n
		// }
		// ? initializeEditor will be called from iframe - editor.js
	},
	/**
	 * Creates a syntax highlighted readonly div with the content just like Prism
	 * @param {Object} monaco Global Monaco Instance
	 */
	colorizeElement: function (monaco) {
		this.setData('monaco', monaco);//No I18n
		this.hasAction( "editor-core-loaded" ) && this.throwEvent('editor-core-loaded');//No I18n
		const options = this.data.ltPropColorizeOptions;
		const colorizeNode = this.$node.querySelector('.colorizeElement code');//No I18n
		monaco.editor.colorizeElement(colorizeNode, options);//No I18n
	},
	/**
	 * This will modify the config of the require
	 * @param {Boolean} insideIframe Whether basefolder has to be added or not
	 * @returns Object
	 */
	getConfigForRequire: function (insideIframe) {
		const data = this.getData();
		let actualPath = _led.pathFor.monaco.baseFolder;
		const i18nLang = data.ltPropI18nLanguage;
		const listOfSupportedLanguages = _led.LANGS_SUPPORTED_BY_MONACO;
		const isLanguageSupported = listOfSupportedLanguages.hasOwnProperty(i18nLang);

		// if (insideIframe && !this.data.ltPropCdnLink ) {
		// 	actualPath = _led.path.relative(_led.pathFor.iframeEditor.baseFolder, actualPath);
		// }
		/**
		 * This function is important as it manipulates the url to
		 * load by modifying its domain
		 * @note This is mainly requested by Qntrl Team for static content deployment
		 * For this purpose, the require's code is slightly modified
		 * Refer `_constructUrl` in require.js 
		 * It will have `_forMonaco` condition where it completely modifies the url
		 * instead of concatenating it. This is done by vignesh.prv
		 * 
		 * @param {String} id AMD Module Id
		 * @param {String} url Url to load for that id
		 * @returns String
		 */
		const constructUrlForMonaco = function (id, url) {
			if (_led.isDomainStatic) {
				url = url.startsWith('./') ? url.slice(2) : url;
				return [_led.domain, (_led.urlMappings[url] || url)].join('/');
			}
			return url;
		}
		const config = {
			waitSeconds: 30,
			'paths': { vs: actualPath }, //No I18n
			urlArgs: _led.urlConstructor || constructUrlForMonaco
			// 'vs/css': { disabled: true }
		};
		config.urlArgs._forMonaco = true;
		if (isLanguageSupported) {
			config["vs/nls"] = { //No I18n
				availableLanguages: {
					"*": i18nLang
				}
			}
		}
		return config;
	},
	/**
	 * This is a wrapper function to easily get values 
	 * For Example,
	 * instead of getting data as `editorInstance` and `diffEditorInstance`
	 *
	 * We can just get `instance` from this function 
	 * and it will give you the current value based on the editor type
	 * 
	 * based on the type of the editor
	 * @param {String} valueToGet Necessary Data Label
	 * @param {String} providedEditorType Type of Editor - this is for overriding purpose (not generally needed)
	 * @returns *
	 */
	basedOnTypeGet: function (valueToGet, providedEditorType) {
		const EditorTypes = Lyte.Editor.EDITOR_TYPES;
		const basicEditor = EditorTypes.BASIC_EDITOR;
		const diffEditor = EditorTypes.DIFF_EDITOR;
		const type = _led.checkType;
		const editorType = providedEditorType || this.data.ltPropEditorType;
		if (!this.valueMappings) {
			this.valueMappings = {
				cacheObject: {
					[basicEditor]: this.data.basicEditorOptionsToUpdate,
					[diffEditor]: this.data.diffEditorOptionsToUpdate
				},
				instance: {
					[basicEditor]: this.getData.bind(this, 'editorInstance'),
					[diffEditor]: this.getData.bind(this, 'diffEditorInstance')
				},
				instanceOfEditor: {
					[basicEditor]: this.getData.bind(this, 'editorInstance'),
					[diffEditor]: function () {
						const diffEditorInstance = this.getData('diffEditorInstance');//No I18n
						if (diffEditorInstance) {
							return diffEditorInstance.getModifiedEditor();
						}
					}
				},
				optionsUpdateMethodName: {
					[basicEditor]: 'onOptionsUpdate',//No I18n
					[diffEditor]: 'onDiffEditorOptionsUpdate'//No I18n
				},
				toolbarState: {
					[basicEditor]: this.getData.bind(this, 'basicToolbarState'),
					[diffEditor]: this.getData.bind(this, 'diffToolbarState')
				},
				providedToolbarData: {
					[basicEditor]: this.getData.bind(this, 'ltPropToolbar'),
					[diffEditor]: this.getData.bind(this, 'ltPropDiffEditorToolbar')
				},
				modelInstance: {
					[basicEditor]: function () {
						const editorInstance = this.data.editorInstance;
						return editorInstance.getModel();
					},
					[diffEditor]: function () {
						const diffEditorInstance = this.data.diffEditorInstance;
						return diffEditorInstance.getModifiedEditor().getModel();
					}
				},
				options: {
					[basicEditor]: this.getData.bind(this, 'ltPropOptions'),
					[diffEditor]: this.getData.bind(this, 'ltPropDiffEditorOptions')
				},
				optionsDataName: {
					[basicEditor]: 'ltPropOptions',//No I18n
					[diffEditor]: 'ltPropDiffEditorOptions'//No I18n
				}
			};
			this.valueMappings.editorState = {
				[basicEditor]: {
					type: basicEditor,
					editorInstance: this.valueMappings.instance[basicEditor],
					toolbar: this.valueMappings.toolbarState[basicEditor]
				},
				[diffEditor]: {
					type: diffEditor,
					editorInstance: this.valueMappings.instance[diffEditor],
					toolbar: this.valueMappings.toolbarState[diffEditor]
				}
			}
		}
		if (Array.isArray(valueToGet)) {
			return valueToGet.reduce(function (acc, valKey) {
				let value = this.valueMappings[valKey][editorType];
				if (type.function(value)) {
					value = value.call(this);
				}
				acc[valKey] = value;
				return acc;
			}.bind(this), {})
		} else {
			const valueObject = this.valueMappings[valueToGet] || {};
			let value = valueObject[editorType];
			if (type.function(value)) {
				return value.call(this);
			}
			return value || null;
		}
	},
	/**
	 * Gives the Options from the Raw options API of monaco instance
	 * Gives the options of modified model incase of Diff Editor
	 * @param {Object} instance Editor Instance
	 * @returns Object
	 */
	getRawOptions: function (instance) {
		const instanceType = instance.getEditorType();
		const monaco = this.data.monaco;
		let rawOptions = {};
		if (monaco) {
			switch (instanceType) {
				case monaco.editor.EditorType.IDiffEditor: {
					rawOptions = instance.getModifiedEditor().getRawOptions();
				}
					break;
				case monaco.editor.EditorType.ICodeEditor: {
					rawOptions = instance.getRawOptions();
				}
					break;
			}
		}
		return rawOptions;
	},
	/**
	 * For some options change, the state has to be modified 
	 * differently, eg., theme. This function is used as a hook for that modification
	 * @param {Object} options modified options
	 * @returns Object
	 */
	modifyOptionsForState: function (options) {
		const modifiedOptions = {};
		for (let key in options) {
			switch (key) {
				case 'theme': {
					modifiedOptions.toggleDarkMode = options[key] === _led.DARK_THEME;
				}
					break;
				default: {
					modifiedOptions[key] = options[key];
				}
			}
		}
		return modifiedOptions;
	},
	/**
	 * Constructing array of arguments for options
	 * @param {Object|String} key 
	 * @param {*} value 
	 * @param {Boolean} internalUpdate 
	 * @param {String} editorType 
	 * @returns Array
	 */
	getArgsForOptionUpdate: function (key, value, internalUpdate, editorType) {
		const type = _led.checkType;
		let options = {};
		if (type.object(key)) {
			options = key;
		} else if (type.string(key)) {
			options = { [key]: value };
		} else {
			_led.throw.error(_led.error.TYPE_MUST_BE, 'object (or) a string key & value', 'options');//No I18n
			return;
		}
		const internalVars = this.basedOnTypeGet(['instance', 'cacheObject'], editorType);//No I18n
		const instance = internalVars.instance;
		const cacheObject = internalVars.cacheObject;
		return [
			instance,
			options,
			cacheObject,
			internalUpdate,
			editorType
		]
	},
	/**
	 * @param {Object} toolObject 
	 * @param {HTMLElement} toolbar 
	 */
	overrideToolsIfNecessary: function (toolObject, toolbar) {
		if (toolObject.hasOwnProperty('options') && !toolObject.options.includes(toolObject.current)) {
			toolbar.component.overrideTools();
		}
	},
	/**
	 * This will add values from toolbar to the instance
	 * @param {Object} instance Monaco Editor Instance
	 * @param {Object} options Options to set
	 * @param {Object} cacheObject 
	 * @param {Boolean} internalUpdate 
	 * @param {String} desiredEditorType 
	 */
	updateOptionsInInstance: function (instance, options, cacheObject, internalUpdate, desiredEditorType) {
		if (instance) {
			const actualEditorType = this.data.ltPropEditorType;
			desiredEditorType = desiredEditorType || actualEditorType;
			const state = this.basedOnTypeGet('toolbarState', desiredEditorType);//No I18n
			Object.assign(cacheObject, options);
			const toolbar = this.data.connectedToolbar || this.$node.querySelector('lyte-editor-toolbar');//No I18n
			if (toolbar) {
				const tools = toolbar.component.data.tools;
				if (internalUpdate !== true && desiredEditorType === actualEditorType) { // ? Dont remove true , it is there for a purpose
					for (let keyName in options) {
						const optionValue = options[keyName];
						switch (keyName) {
							case 'theme': {
								const toggleDarkMode = optionValue === _led.DARK_THEME ? true : (optionValue === _led.LIGHT_THEME ? false : null);
								if (toggleDarkMode !== null) {
									const toolObject = tools.leftAligned.toggleDarkMode || tools.rightAligned.toggleDarkMode || {};
									Lyte.Component.set(toolObject, 'current', toggleDarkMode);//No I18n
									Lyte.Component.set(state, keyName, toggleDarkMode);
									this.overrideToolsIfNecessary(toolObject, toolbar);
								}
							}
								break;
							case 'fontSize': {
								const toolObject = tools.leftAligned[keyName] || tools.rightAligned[keyName] || {};
								Lyte.Component.set(toolObject, 'current', optionValue);//No I18n
								Lyte.Component.set(state, keyName, optionValue);
								this.overrideToolsIfNecessary(toolObject, toolbar);
							}
								break;
							case 'toggleWrap': {
								const toolObject = tools.leftAligned[keyName] || tools.rightAligned[keyName] || {};
								Lyte.Component.set(toolObject, 'isActive', optionValue === 'on');//No I18n
								Lyte.Component.set(state, keyName, optionValue);
								this.overrideToolsIfNecessary(toolObject, toolbar);
							}
								break;
							case 'formatOnType': {
								const toolObject = tools.leftAligned[keyName] || tools.rightAligned[keyName] || {};
								Lyte.Component.set(toolObject, 'isActive', optionValue);//No I18n
								Lyte.Component.set(state, keyName, optionValue);
								this.overrideToolsIfNecessary(toolObject, toolbar);
							}
								break;
						}
					}
				} else {
					const modifiedOptions = this.modifyOptionsForState(options);
					Object.assign(state, modifiedOptions);
				}
			}
			instance.updateOptions(options);
		}
	},
	/**
	 * Get args for update and set those values in the instance
	 * @param {String} key 
	 * @param {String} value 
	 * @param {Boolean} internalUpdate 
	 * @param {String} editorType 
	 */
	updateOptionsWrapper: function (key, value, internalUpdate, editorType) {
		const argsForUpdate = this.getArgsForOptionUpdate(
			key,
			value,
			internalUpdate,
			editorType
		);
		this.updateOptionsInInstance.apply(this, argsForUpdate);
	},
	didConnect: function () {
		const data = this.getData();
		if (data.hasYieldedToolbar) {
			this.addEventListenersToTools();
		}
		// const actualPath = _led.pathFor.monaco.baseFolder;
		const config = this.getConfigForRequire();
		if (data.ltPropColorize) {
			if (window.monaco) {
				this.colorizeElement(window.monaco);
			} else {
				_led.loadResources(_led.pathFor.monaco.loaderFile, document, null, null, (function () {//No I18n
					require.config(config);
					require(["vs/editor/editor.main"], this.colorizeElement.bind(this)); //No I18n
				}).bind(this));
			}
		} else if (data.ltPropRenderInShadowRoot) {
			this.activateEditorBasedOnType(this.$node);
			const states = _led.state.registeredStates;
			const monacoLoadingTriggered = states.MONACO_LOADING_TRIGGERED;
			const monacoLoaded = states.MONACO_LOADED;
			const isLoadingOfMonacoTriggered = monacoLoadingTriggered.value;
			const isMonacoLoaded = monacoLoaded.value;
			if (isMonacoLoaded) {
				this.initializeEditor(document, window, window.monaco);
			} else {
				if (isLoadingOfMonacoTriggered) {
					monacoLoaded.oneTimeListener(function () {
						this.initializeEditor(document, window, window.monaco);
					}.bind(this));
				} else {
					monacoLoadingTriggered.set(true);
					_led.loadResources(_led.pathFor.monaco.loaderFile, document, null, null, (function () {//No I18n
						require.config(config);
						require(["vs/editor/editor.main"], function () { //No I18n
							monacoLoaded.set(true);
							this.initializeEditor(document, window, window.monaco);
						}.bind(this)); //No I18n
					}).bind(this));
				}
			}
		}
		this.throwCustomEvent('load', this);
	},
	/**
	 * Will dispose all listeners
	 * Will remove all arg caches
	 * and flushes out the node references for current id
	 */
	didDestroy: function () {
		this.disposables[this.data._id].disposeAll();
		//destroy all

		if(this.folder){
			this.folder.dispose();
		}
		if(this.data.placeHolderTimeout){
			clearTimeout(this.data.placeHolderTimeout);	
		}
		if(this.data.switchFileTimeout){
			clearTimeout(this.data.switchFileTimeout);
		}

		///
		if (this.data.editorInstance) {
			this.data.editorInstance.dispose();
		}
		if (this.data.diffEditorInstance) {
			this.data.diffEditorInstance.dispose();
		}
		if(!this.data.ltPropRenderInShadowRoot) {
			_led.pubsub.fire('MONACO_UNLOADED');
		}
		this.disposeUtils();
		delete this.argsCache[this.data._id];
		delete this.disposables[this.data._id];
		delete this.disposeUtils;
		delete this.data.editorInstance;
		delete this.data.diffEditorInstance;
		delete this.valueMappings;

		// managing folder instance
		// if(this.folder){
		// 	this.folder.dispose();
		// }
		// if(this.data.placeHolderTimeout){
		// 	clearTimeout(this.data.placeHolderTimeout);	
		// }
		// if(this.data.switchFileTimeout){
		// 	clearTimeout(this.data.switchFileTimeout);
		// }
		_led.flush(this.getData('_id'));
	},
	changeFileContent : function( editorInstance, curValue,saveOnOriginal){
		const file = this.directory.getCurrentlyActiveFile();
		const currentModel = editorInstance.getModel();
		const tabIsDirty = true || editor.hasModifiedContent();
		if (!file) {
			return;
		}
		if (!currentModel._programmaticValueSet) {
			if (currentModel._isLyteRestrictedModel) {
				file.setValue(curValue,saveOnOriginal);
			}
			else if (file.noBlueprints || !file.internal) {
				file.setValue(curValue,saveOnOriginal);
			}
			else {
				const currentCodeBlock = editor.restrictedEditor.getCurrentCodeBlock();
				const mutableValues = currentCodeBlock.getMutableValues();
				file.setValue(curValue,saveOnOriginal);
				file.updateMutableValues(mutableValues);
			}
		}
		this.directory.setDirtyStateOfFile(file.uniqueId, tabIsDirty);
	},
	actions: { // these 3 actions are just redirectors
		triggerEditorAction: function () {
			this.$node.triggerAction.apply(this, arguments);
		},
		updateOptions: function (key, value) {
			this.updateOptionsWrapper(key, value, true);
		},
		iframeLoaded: function (iframe) {
			this.activateEditorBasedOnType(iframe.contentDocument.body);
			this.injectSourceFiles(iframe);
		},
		hideEditor : function( flag ){
			this.setData( "hideEditor", flag );
		},
		closeFileSaveModal : function( value ){
			const dirtyPromise = this._dirtyPromise;
			if( value === "save" ){
				//have to handle save here
			}else if( value === "close" ){
				dirtyPromise.success();
			}else{
				dirtyPromise.reject();
			}
		}
	},
	methods: {
		checkTheme: function (node) {
			/**
			 * !Deprecated Content. Has to be removed in next version 
			 */
			// const editorInstance = this.getData('editorInstance');
			// if (editor) {
			// 	const currentTheme = editor._themeService.getTheme().themeName;
			// 	const darkModeClass = _led.DARK_MODE_CLASS;//No I18n
			// 	if (currentTheme === _led.DARK_THEME) {
			// 		node.setData('ltPropWrapperClass', [wrapperClass, darkModeClass].join(' '));//No I18n
			// 	} else {
			// 		node.setData('ltPropWrapperClass', wrapperClass);//No I18n
			// 	}
			// }
		},
		tabItemActivated : function (file) {
			this.directory.openFile(file.uniqueId);
		},
		beforeTabClose : function (event, file) {
			const self = this;
			return new Promise( function( resolve, reject ){
				new Promise( function( success, failure ) {
					// const returnValue = self.directory.canCloseFile(file.uniqueId);
					// if( !returnValue.value ){
					// 	this.setData( {
					// 		"isDirtyFile" : true,
					// 		"warningsMsg" : "Do you want to save the changes of " + file.name + " ?"
					// 	});
					// 	self._dirtyPromise = {
					// 		success : success,
					// 		failure : failure
					// 	};
					// }else{
						success();
					// }
				}).then( function(){
					const callback = self.triggerMethod("onBeforeFileClose",self.directory.getFileModelObj(file.uniqueId));
					if( callback === false ){
						reject();
					}else if( callback && callback.then ){
						callback.then( resolve() ).catch( function( err ){ reject() } );	
					}else{
						resolve();
					}
				}).catch( function(){
					reject();
				})
			});
		},
		toolIconClick : function(tool,event){
			if(this.getMethods('onEditorToolIconClick')){
				this.executeMethod('onEditorToolIconClick' , tool , this);
			}
		}
	},
	observer: function (changeObj) {
		const basicEditorInstance = this.data.editorInstance;
		const diffEditorInstance = this.data.diffEditorInstance;
		const monaco = this.data.monaco;
		if ((basicEditorInstance || diffEditorInstance) && changeObj) {
			switch (changeObj.item) {
				case 'ltPropValue': {
					if (!this.preventObserverLooping) {
						if (basicEditorInstance) {
							if (this.data.valueLoadedFromModel) {
								const newModel = monaco.editor.createModel(changeObj.newValue, this.data.ltPropLanguage);
								basicEditorInstance.setModel(newModel);
							} else {
								if(basicEditorInstance.getRawOptions().readOnly ){
									basicEditorInstance.setValue(changeObj.newValue);
								}else if( this.data.ltPropPreventUndoRedo && this.data.ltPropPreventUndoRedo.value ){
									basicEditorInstance.setValue(changeObj.newValue );
									this.data.ltPropPreventUndoRedo.value = false;
								}
								else
								{
									basicEditorInstance.pushUndoStop()
									basicEditorInstance.executeEdits('content-changed', [
									{
										range: basicEditorInstance.getModel().getFullModelRange(),
										text: changeObj.newValue
									}
									])
									basicEditorInstance.pushUndoStop()
								}
							}
							this.setData('valueLoadedFromModel', false);
						}
						if( this.data.ltPropPlaceholder ){
							this.showPlaceholder( changeObj.newValue );
						}
					}
					// this.preventObserverLooping = false;
				}
					break;
				case 'ltPropLanguage': {
					if (basicEditorInstance) {
						monaco.editor.setModelLanguage(basicEditorInstance.getModel(), changeObj.newValue);
					}
				}
					break;
				case 'ltPropResourceStrings': {
					if (changeObj.type === 'array') {
						changeObj.insertedItems.forEach(function (lib) {
							_led.addLib(monaco, lib);
						})
					} else if (changeObj.type === 'change') {
						_led.refreshAllLibs(monaco, changeObj.newValue);
					}
				}
					break;
				case 'ltPropResourceLinks': {
					if (changeObj.type === 'array') {
						changeObj.insertedItems.forEach(function (link) {
							_led.addLibFrom(monaco, link, this);
						}.bind(this))
					} else if (changeObj.type === 'change') {
						_led.refreshAllLibsFrom(monaco, changeObj.newValue, this);
					}
				}
					break;
				case 'ltPropCustomCssPath': {
					this.loadCustomCssToDoc(changeObj.newValue);
				}
					break;
				case 'ltPropEditorType': {
					// if (!this._internalChangeForLtPropEditorType) {
					const newValue = changeObj.newValue;
					const oldValue = changeObj.oldValue;
					const argsCache = this.argsCache[this.data._id];
					const currentEditorState = this.basedOnTypeGet('editorState', oldValue);//No I18n
					// const proceedToChangeEditorType = this.triggerMethod('onBeforeEditorTypeChange', currentEditorState);
					// if (proceedToChangeEditorType !== false) {
					if (newValue === Lyte.Editor.EDITOR_TYPES.BASIC_EDITOR && !this.data.editorInstance) {
						argsCache.callFn.call(this, 'initializeBasicEditor');//No I18n
					} else if (newValue === Lyte.Editor.EDITOR_TYPES.DIFF_EDITOR && !this.data.diffEditorInstance) {
						argsCache.callFn.call(this, 'initializeDiffEditor');//No I18n
					}
					if (this.data.ltPropRenderInShadowRoot) {
						this.activateEditorBasedOnType(this.$node);
					} else {
						const iframe = this.$node.querySelector('#' + this.data._id);
						const iframeBody = iframe.contentDocument.body;
						this.activateEditorBasedOnType(iframeBody);
					}
					const newEditorState = this.basedOnTypeGet('editorState', newValue);//No I18n
					// Here, currentEditorState - will be previous editor state
					const providedToolbarData = this.basedOnTypeGet('providedToolbarData');//No I18n
					this.setData({
						providedToolbarData: [].concat(providedToolbarData) || [],
						hasToolbarData: !!providedToolbarData
					});
					this.applyCurrentToolbarData();
					this.triggerMethod('onEditorTypeChange', newEditorState, currentEditorState);//No I18n
					// } else {
					// 	this._internalChangeForLtPropEditorType = true;
					// 	this.data.ltPropEditorType = oldValue;
					// 	// this.setData('ltPropEditorType', oldValue);
					// 	delete this._internalChangeForLtPropEditorType;
					// }
					// }
				}
					break;
				case 'ltPropModifiedDiffModel.value':
				case 'ltPropModifiedDiffModel.language':
				case 'ltPropOriginalDiffModel.language':
				case 'ltPropOriginalDiffModel.value': {
					if (!this.preventObserverLooping) {
						const item = changeObj.item;
						const objectName = item.split('.')[0];
						const changedKey = item.split('.')[1];
						const dataName = objectName.replace(/^ltProp([A-Z])(.*)$/, function () {
							const args = Array.from(arguments);
							return args[1].toLowerCase() + args[2];
						})
						this.updateDiffModel({
							changedKey: changedKey,
							modelDef: this.data[objectName],
							dataName: dataName
						});
						this.loadDiffModelToInstance();
					}
					this.preventObserverLooping = false;
				}
					break;
				case 'ltPropToolbar':{
					const isChange = changeObj.type == "change";
					if(isChange){
						const providedToolbarData = this.basedOnTypeGet('providedToolbarData');//No I18n
						this.setData("providedToolbarData",[].concat(providedToolbarData));
					}
					else{
						// const providedToolbarData = this.basedOnTypeGet('providedToolbarData');//No I18n
						// this.setData("providedToolbarData",providedToolbarData);
						
						const insertedItem = changeObj.insertedItems;
						if(insertedItem){
							const index = changeObj.index;
							Lyte.arrayUtils(this.data.providedToolbarData , 'insertAt' , index , insertedItem);
						}
						else{
							const removedItem = changeObj.removedItems;
							const index = changeObj.index;
							Lyte.arrayUtils(this.data.providedToolbarData , 'removeAt' , index , removedItem.length);
						}
						
					}
					
				}
			}
			
		}
	}.observes(
		//ignorei18n_start
		'ltPropValue',
		'ltPropLanguage',
		'ltPropToolbar.[]',
		'ltPropResourceStrings',
		'ltPropResourceStrings.[]',
		'ltPropResourceLinks',
		'ltPropResourceLinks.[]',
		'ltPropCustomCssPath',
		'ltPropEditorType',
		'ltPropOriginalDiffModel.value',
		'ltPropOriginalDiffModel.language',
		'ltPropOriginalDiffModel.uri',
		'ltPropModifiedDiffModel.value',
		'ltPropModifiedDiffModel.language',
		'ltPropModifiedDiffModel.uri'
		//ignorei18n_end
	),
	leftPanelObserver : function(changeObj){
		if(this.data.ltPropShowLeftPanel && !this.data.leftPanelInitialized) {
				this.setData('leftPanelInitialized',true);
				this.initializeLeftPanel();
		}
		else{
			this.setData('hideEditor',false);
			// this.initializePlaceHolder();
			// this.showPlaceholder("");
		}	
	}.observes('ltPropShowLeftPanel').on('init'),
	fileExplorerObserver : function(changeObj){
				const newVal = changeObj.newValue;
				const resetPubsub = "RESETTABBAR"; //No I18n
				const id = '_id'; //No I18n
				const fileExplorer = "ltPropFileExplorerData"; //No I18n
				const directoryPanelItem = "directoryPanelItem"; //No I18n
				this.pubsub.fire(resetPubsub);
				this.folder.resetUserDirectory();
				 const editorInstance = _led.getInstance(this.getData(id));
				this.folder.userDirectory(this.getData(fileExplorer));
				// setTimeout(function(){this.setFileExplorerRestrictMenu('menu',false);}.bind(this),0);
				this.setData(
          directoryPanelItem,
          editorInstance.directory.getDirectoryList()
        );	
	}.observes('ltPropFileExplorerData'), //No I18n
	toolbarDataChangeObserver: function (changeObj) {
		const toolbar = this.data.connectedToolbar;
		if (toolbar) {
			const dataNameMap = {
				//ignorei18n_start
				providedToolbarData: 'toolbar'
				//ignorei18n_end
			};
			switch (changeObj.item) {
				case 'toolsInstance':
				case 'currentToolbarData':
				case 'providedToolbarData': {
					const actualDataName = dataNameMap[changeObj.item] || changeObj.item;
					toolbar.setData(actualDataName, changeObj.newValue);
				}
					break;
			}
		}
	}.observes(
		//ignorei18n_start
		'providedToolbarData',
		'currentToolbarData',
		'toolsInstance'
		//ignorei18n_end
	),
	hideEditor : function(changeObj) {
		if(!changeObj.newValue) {
			this.$node.updateEditorLayout();
		}
	}.observes("hideEditor"),
	mediaObserver : function(changeObj) {
		this.setData("hideEditor", !!changeObj.newValue);
	}.observes("media"),
	ltPropHiddenState : function() {
		const ltPropHiddenState = this.data.ltPropHiddenState;
		if(ltPropHiddenState) {
			const mediaData = this.data.media;
			if(mediaData && ["video", "audio"].includes(mediaData.type)) {
				const mediaDom = this.$node.querySelector(mediaData.type);
				mediaDom.pause();
			}
		}
	}.observes('ltPropHiddenState'),
	utils: function () {
		const utils = {
			/**
			 * This function will be used to load the basic editor
			 * if ltPropLoadOnDemand is set to true
			 */
			loadBasicEditor: function () {
				const fnName = 'loadBasicEditor';//No I18n
				const argsCache = this.argsCache[this.data._id];
				if (this.data.ltPropLoadOnDemand[Lyte.Editor.EDITOR_TYPES.BASIC_EDITOR]) {
					if (argsCache.hasFn(fnName)) {
						argsCache.callFnAndRmCache.call(this, fnName);
					} else {
						this.data._loadBasicEditorTriggered = true;
					}
				}
			},
			/**
			 * This function will be used to load the diff editor
			 * if ltPropLoadOnDemand is set to true
			 */
			loadDiffEditor: function () {
				const fnName = 'loadDiffEditor';//No I18n
				const argsCache = this.argsCache[this.data._id];
				if (this.data.ltPropLoadOnDemand[Lyte.Editor.EDITOR_TYPES.DIFF_EDITOR]) {
					if (argsCache.hasFn(fnName)) {
						argsCache.callFnAndRmCache.call(this, fnName);
					} else {
						this.data._loadDiffEditorTriggered = true;
					}
				}
			},
			/**
			 * This will return some basic information from the current model
			 * @param {Boolean} fromSelection 
			 * @returns Object
			 */
			getModelInfo: function (fromSelection) {
				const model = this.basedOnTypeGet('modelInstance');//No I18n
				const fullRange = model.getFullModelRange();
				const populateInfo = function (range) {
					return {
						characterCount: model.getCharacterCountInRange(range),
						lineCount: range.endLineNumber - range.startLineNumber + 1,
						range: {
							startLineNumber: range.startLineNumber,
							endLineNumber: range.endLineNumber,
							startColumn: range.startColumn,
							endColumn: range.endColumn
						}
					}
				}
				const modelInfo = populateInfo(fullRange)
				if (fromSelection) {
					const instance = this.basedOnTypeGet('instance');//No I18n
					const selections = instance.getSelections();
					modelInfo.selections = selections.map(populateInfo).sort(function (sel1, sel2) {
						const range1 = sel1.range;
						const range2 = sel2.range;
						const sameLine = range1.startLineNumber === range2.startLineNumber;
						return sameLine ? range1.startColumn - range2.startColumn : range1.startLineNumber - range2.startLineNumber;
					});
				}
				return modelInfo;
			},
			/**
			 * Used to update the options of basic editor by the user
			 * @param {String} key Options label
			 * @param {*} value 
			 */
			updateOptions: function (key, value) {
				const desiredEditorType = Lyte.Editor.EDITOR_TYPES.BASIC_EDITOR;
				const actualEditorType = this.data.ltPropEditorType;
				const args = [key, value, false, desiredEditorType];
				// const toolbar = this.data.connectedToolbar || this.$node.querySelector('lyte-editor-toolbar');//No I18n
				if (desiredEditorType === actualEditorType) {
					/**
					 * This is done because the user could have opened diff editor
					 * and triggered update options in the basic editor, so 
					 * the toolbar for the diff editor should not be updated based
					 * on this options change
					 * 
					 * This option changes has to be updated when the editor type changes
					 */
					this.applyCurrentToolbarData();
				}
				this.updateOptionsWrapper.apply(this, args);
			},
			/**
			 * Used to update the options of diff editor by the user
			 * @param {String} key Options label
			 * @param {*} value 
			 */
			updateDiffEditorOptions: function (key, value) {
				const desiredEditorType = Lyte.Editor.EDITOR_TYPES.DIFF_EDITOR;
				const actualEditorType = this.data.ltPropEditorType;
				const args = [key, value, false, desiredEditorType];
				// const toolbar = this.data.connectedToolbar || this.$node.querySelector('lyte-editor-toolbar');//No I18n
				if (desiredEditorType === actualEditorType) {
					/**
					 * This is done because the user could have opened diff editor
					 * and triggered update options in the basic editor, so 
					 * the toolbar for the diff editor should not be updated based
					 * on this options change
					 * 
					 * This option changes has to be updated when the editor type changes
					 */
					this.applyCurrentToolbarData();
				}
				this.updateOptionsWrapper.apply(this, args);
			},
			/**
			 * This will create a Diff Navigator instance
			 * @param {Object} options options for navigator instance
			 * @returns Object
			 */
			createDiffNavigator: function (options) {
				const monaco = this.data.monaco;
				const diffEditorInstance = this.data.diffEditorInstance;
				const diffNavigatorInstance = this.data.diffNavigatorInstance;
				if (!diffNavigatorInstance) {
					if (monaco && diffEditorInstance) {
						const navigatorInstance = monaco.editor.createDiffNavigator(diffEditorInstance, options);
						this.setData('diffNavigatorInstance', navigatorInstance);//No I18n
					} else {
						_led.throw.warning('Monaco Editor and diffEditorInstance has to be present for creating diffNavigator');//No I18n
						return null;
					}
				}
				return this.data.diffNavigatorInstance;
			},
			/**
			 * This will update Navigator Options in the diff editor
			 * This will not check for editor type, because there is no navigator
			 * options in basic editor.
			 * To know more about navigator options refer monaco editor documentation
			 * @param {String} key Options Label
			 * @param {*} value 
			 * @returns 
			 */
			updateDiffNavigatorOptions: function (key, value) {
				const diffNavigatorInstance = this.data.diffNavigatorInstance;
				if (diffNavigatorInstance) {
					const monaco = this.data.monaco;
					const diffEditorInstance = this.data.diffEditorInstance;
					const type = _led.checkType;
					let options = {};
					if (type.object(key)) {
						options = key;
					} else if (type.string(key)) {
						options = { [key]: value };
					} else {
						_led.throw.error(_led.error.TYPE_MUST_BE, 'object (or) a string key & value', 'options');//No I18n
						return;
					}
					diffNavigatorInstance.dispose();
					const navigatorInstance = monaco.editor.createDiffNavigator(diffEditorInstance, options);
					this.setData('diffNavigatorInstance', navigatorInstance);//No I18n
					return navigatorInstance;
				}
				_led.throw.warning('DiffNavigatorInstance is not available');//No I18n
				return null;
			},
			/**
			 * This will trigger the necessary action for the tool
			 * and will update the options accordingly
			 * @param {String} action Name of the action to trigger
			 * @param {*} value Any Value - mostly string
			 * @param {Object} tool Current Tool Object
			 * @param {HTMLElement} node Tool node
			 * @param {Object} event Event Object	
			 */
			triggerAction: function (action, value, tool, node, event) {
				const instance = this.basedOnTypeGet('instance');//No I18n
				const id = this.getData('_id');
				const actionsMap = _led.ACTIONS_MAP;
				const type = _led.checkType;
				if (tool && tool.hasOwnProperty('throwEvent')) {
					const throwEvent = tool.throwEvent;
					if (type.boolean(throwEvent) && throwEvent) {
						this.triggerMethod('onToolClick', tool, node, event);//No I18n
					}
					// Revert Back to Boolean Type 
					// else if (type.object(throwEvent)) {
					// 	const editorType = this.data.ltPropEditorType;
					// 	if (type.boolean(throwEvent[editorType]) && throwEvent[editorType]) {
					// 		this.triggerMethod('onToolClick', tool, node, event);//No I18n
					// 	}
					// }
				} else if (actionsMap.hasOwnProperty(action)) {
					_led.prerequisitesForAction(action, instance);
					instance.trigger(id, actionsMap[action]);
				} else if (instance) {
					const state = this.basedOnTypeGet('toolbarState');//No I18n
					const rawOptions = this.getRawOptions(instance);
					switch (action) {
						case 'theme': {
							let options = this.basedOnTypeGet('options');//No I18n
							const optionsDataName = this.basedOnTypeGet('optionsDataName');//No I18n
							if (options === undefined) {
								options = {};
								this.setData(optionsDataName, options);//No I18n
							}
							const connectedLayout = this.data.connectedLayout;
							const dropOptions = document.querySelector('.lyteEditorFontOptions');
							const menu = document.querySelector('.leMenu').parentElement;
							const nodesToChange = [dropOptions, this.$node,menu];
							if (connectedLayout) {
								nodesToChange.push(connectedLayout);
							}
							const darkModeClass = _led.DARK_MODE_CLASS;
							const addClass = function (nodeToAddClass) {
								return nodeToAddClass && nodeToAddClass.classList.add(darkModeClass)
							};
							const removeClass = function (nodeToRemoveClass) {
								return nodeToRemoveClass && nodeToRemoveClass.classList.remove(darkModeClass)
							};
							const theme = value;
							const scopedToolbar = this.$node.querySelector('lyte-editor-toolbar');//No I18n
							const toolbar = this.data.connectedToolbar || scopedToolbar;
							if (value === _led.DARK_THEME) {
								nodesToChange.forEach(addClass);
								if (toolbar) {
									const toolName = 'toggleDarkMode';
									const infoOfThemeTool = toolbar.getInfoOfTool(toolName);
									Lyte.Component.set(infoOfThemeTool, 'current', true);//No I18n
								}
							} else {
								nodesToChange.forEach(removeClass);
							}
							if (options.theme !== value) {
								instance._themeService.setTheme(theme);
								Lyte.Component.set(state, action, value);
								Lyte.Component.set(this.data.ltPropOptions, 'theme', theme);//No I18n
								const methodName = this.basedOnTypeGet('optionsUpdateMethodName');//No I18n
								this.triggerMethod(methodName, {
									theme: theme
								}, this.data.ltPropOptions);
							}
						}
							break;
						case 'toggleWrap': {
							const optionToSet = tool ? (rawOptions.wordWrap === 'on' ? 'off' : 'on') : value;//No I18n
							this.updateOptionsWrapper('wordWrap', optionToSet, true);//No I18n
							const toolObj = tool || this.data.toolsInstance[action];
							// const classToAdd = toolObj.class;
							// if (classToAdd) {
							// const wrapper = this.data.connectedToolbar || node || this.$node;
							// let toolItem = wrapper.querySelector('.' + classToAdd);
							// if (toolItem) {
							const valueToSet = optionToSet === 'on';//No I18n
							Lyte.Component.set(toolObj, 'isActive', valueToSet);//No I18n
							Lyte.Component.set(state, action, optionToSet);
							// }
							// }
						}
							break;
						case 'fontSize': {
							this.updateOptionsWrapper('fontSize', value, true);//No I18n
							const toolObj = tool || this.data.toolsInstance[action];
							Lyte.Component.set(toolObj, 'current', value);//No I18n
							Lyte.Component.set(state, action, value);
						}
							break;
						case 'reset': {
							const editorType = this.data.ltPropEditorType;
							if (editorType === Lyte.Editor.EDITOR_TYPES.BASIC_EDITOR) {
								if( this.data.ltPropOptions && this.data.ltPropOptions.readOnly ){
									instance.setValue(this.data.ltPropDefaultValue);
								}else
								{
									instance.pushUndoStop()
									instance.executeEdits('content-changed', [
									{
										range: instance.getModel().getFullModelRange(),
										text: this.data.ltPropDefaultValue
									}
									])
									instance.pushUndoStop()
								}
								// instance.setValue(this.data.ltPropDefaultValue);
								this.data.ltPropValue = this.data.ltPropDefaultValue;
							}
						}
							break;
						case 'formatOnType': {
							const optionToSet = tool ? !rawOptions.formatOnType : value;//No I18n
							this.updateOptionsWrapper('formatOnType', optionToSet, true);//No I18n
							const toolObj = tool || this.data.toolsInstance[action];
							// const classToAdd = toolObj.class;
							// if (classToAdd) {
							// const wrapper = this.data.connectedToolbar || node || this.$node;
							// let toolItem = wrapper.querySelector('.' + classToAdd);
							// if (toolItem) {
							Lyte.Component.set(toolObj, 'isActive', optionToSet);
							Lyte.Component.set(state, action, optionToSet);
							// }
							// }
						}
					}
				}
			},
			/**
			 * Will check whether the content has changed
			 * @param {boolean} excludeFormat 
			 * @returns Boolean
			 */
			hasModifiedContent: function (excludeFormat) {
				const actualContent = this.data.ltPropValue;
				const defaultContent = this.data.ltPropDefaultValue;
				const language = this.data.ltPropLanguage;
				return !_led.checkEquality(actualContent, defaultContent, language, excludeFormat);
			},
			hasModifiedDiff : function(){
				const instance = this.data.diffEditorInstance;
				const changes = instance.getLineChanges();
				return !!changes.length;
			},
			/**
			 * This will return the list of wiggly lines in the editor
			 * @param {String} type Severity Types
			 * @returns Array
			 */
			getMarkingsInModel: function (type) {
				const model = this.basedOnTypeGet('modelInstance');//No I18n
				const modelId = model.id;
				const monaco = this.data.monaco;
				const severity = monaco.MarkerSeverity;
				let markers = [];
				const filterOutRequiredContents = function (marker) {
					return {
						startColumn: marker.startColumn,
						startLineNumber: marker.startLineNumber,
						endColumn: marker.endColumn,
						endLineNumber: marker.endLineNumber,
						message: marker.message,
						severity: severity[marker.severity],
						code : marker.code
					}
				}
				if (type === undefined) {
					markers = monaco.editor.getModelMarkers({resource : model.uri});
				} else if (!_led.checkType.number(type) && severity.hasOwnProperty(type)) {
					markers = monaco.editor.getModelMarkers({resource : model.uri}).filter(function (marker) {
						return marker.severity === severity[type]
					}).map(filterOutRequiredContents)
				}
				return markers.map(filterOutRequiredContents);
			},
			/**
			 * Labelled Libs - Grouped Util function
			 * Will use a shared cache object from lyte editor
			 * Adds and removes the libs in the cache, so that it can be easily
			 * loaded and unloaded from the monaco editor text model
			 */
			labelledLibs: (function () {
				const cache = _led.cache;
				const objectCheck = _led.checkType.object;
				const arrayCheck = _led.checkType.array;
				const stringCheck = _led.checkType.string;
				const addAs = function (datatype, objectToAdd, overwrite) {
					const monaco = this.data.monaco;
					const mappings = {
						string: 'add',
						link: 'addLink'
					}
					const fnToCall = mappings[datatype];
					if (fnToCall) {
						if (objectCheck(objectToAdd)) {
							for (let label in objectToAdd) {
								const value = objectToAdd[label];
								if (stringCheck(value)) {
									objectToAdd[label] = [value];
								} else if (!arrayCheck(value)) {
									_led.throw.warning(_led.error.EXPECTED, 'string (or) array', { [label]: value })
								}
							}
							_led.cache[fnToCall](monaco, objectToAdd, this, overwrite);
						} else {
							_led.throw.warning(_led.error.EXPECTED, 'object', objectToAdd);//No I18n
						}
					}
				}
				return {
					getAll: cache.list,
					getActive: cache.active,
					emptyCache: cache.emptyCache,
					resetLibs: function () {
						const monaco = this.data.monaco;
						return cache.reinitialize(monaco);
					}.bind(this),
					add: addAs.bind(this, 'string'),
					addLink: addAs.bind(this, 'link'),
					removeFromCache: cache.removeFromCache,
					modify: function (toActivate, toDeactivate) {
						const monaco = this.data.monaco;
						cache.storeActiveState();
						if (arrayCheck(toDeactivate)) {
							cache.deactivate(toDeactivate)
						} else if (toDeactivate === true) {
							cache.deactivateAll()
						}
						if (arrayCheck(toActivate)) {
							cache.activate(toActivate)
						} else if (toActivate === true) {
							cache.activateAll()
						}
						cache.loadActiveLibs(monaco);
					}.bind(this)
				}
			}.call(this)),
			/**
			 * Restricted Editor - creates a partly editable areas in the editor
			 * This is not a functionality of monaco
			 */
			restrictedEditor: (function () {
				const type = _led.checkType;
				const createdCodeBlocks = [];
				/**
				 * This will create an instance of codeblock from the 
				 * previously registered code block templates
				 * @param {String} uid 
				 * @param {String} codeBlockName Code block template name
				 * @param {Object} options Options for the Code block
				 * @returns Object
				 */
				const create = function (uid, codeBlockName, options) {
					options = options ? options : {};
					if (type.string(uid) && type.string(codeBlockName) && (type.object(options) || type.string(options))) {
						const codeBlockInstance = _led.codeBlock[codeBlockName];
						if (codeBlockInstance) {
							const monaco = this.data.monaco;
							const entityOfCodeBlock = codeBlockInstance.createEntity(uid, monaco, options);
							createdCodeBlocks.push(entityOfCodeBlock);
							return entityOfCodeBlock;
						}
						_led.throw.error(_led.error.NOT_FOUND, codeBlockName, 'CodeBlock');//No I18n
					} else {
						const errorMessage = [
							_led.error.EXPECTED('string', typeof uid, 'uid'),//No I18n
							_led.error.EXPECTED('string', typeof codeBlockName, 'codeBlockName'), //No I18n
							_led.error.EXPECTED('object (or) string', typeof options, 'options') //No I18n
						].join('\n');//No I18n
						_led.throw.error(errorMessage);
					}
				};
				/**
				 * Sets the model the current editor instance
				 */
				const setModelToEditor = function (entityOfCodeBlock, defaultValue, codeBlockInstance) {
					const monaco = this.data.monaco;
					const instanceOfEditor = this.basedOnTypeGet('instanceOfEditor');//No I18n

					// On Model Loaded in Editor
					const editorType = this.data.ltPropEditorType;
					const EditorTypes = Lyte.Editor.EDITOR_TYPES;
					switch (editorType) {
						case EditorTypes.BASIC_EDITOR: {
							const uri = entityOfCodeBlock.uri;
							const createdModelInstance = monaco.editor.getModel(uri);
							instanceOfEditor.setModel(createdModelInstance);
							const value = instanceOfEditor.getValue();
							const language = entityOfCodeBlock.language;
							this.setData({
								ltPropDefaultValue: defaultValue !== undefined ? defaultValue : value,
								ltPropValue: value,
								ltPropLanguage: language
							})
						}
							break;
						case EditorTypes.DIFF_EDITOR: {
							let modifiedDiffModel = this.data.modifiedDiffModel;
							let originalDiffModel = this.data.originalDiffModel;
							const fileName = entityOfCodeBlock.id;
							const options = entityOfCodeBlock._options;
							const language = entityOfCodeBlock.language;
							const uri = entityOfCodeBlock.uri;
							if (!modifiedDiffModel) {
								modifiedDiffModel = monaco.editor.getModel(uri);
							}
							if (!originalDiffModel) {
								originalDiffModel = monaco.editor.getModel(uri);
							}
							codeBlockInstance.addRestrictionsToModel(
								fileName,
								modifiedDiffModel,
								options,
								language,
								uri,
								entityOfCodeBlock
							);
							originalDiffModel.setValue(modifiedDiffModel.getValue());
							this.setData('modifiedDiffModel', modifiedDiffModel);//No I18n
							this.setData('originalDiffModel', originalDiffModel);//No I18n
							this.loadDiffModelToInstance();
						}
							break;
					}
				}.bind(this);
				/**
				 * This will load the model generated from code block to the editor instance
				 * @param {String} uid 
				 * @param {String} codeBlockName Code block label
				 * @param {Object} options Options for Code block
				 * @param {String} defaultValue Default values
				 * @returns 
				 */
				const load = function (uid, codeBlockName, options, defaultValue) {
					options = options ? options : {};
					if (type.codeBlockEntity(uid)) {
						const codeBlockInstance = _led.codeBlock[uid.instanceName];
						const entityOfCodeBlock = uid;
						setModelToEditor(entityOfCodeBlock, defaultValue, codeBlockInstance);
						return entityOfCodeBlock;
					} else {
						if (type.string(uid) && type.string(codeBlockName) && (type.object(options) || type.string(options))) {
							const codeBlockInstance = _led.codeBlock[codeBlockName];
							if (codeBlockInstance && codeBlockInstance.createdEntities.hasOwnProperty(uid)) {
								const entityOfCodeBlock = codeBlockInstance.createdEntities[uid];
								entityOfCodeBlock.updateEntity(options);
								setModelToEditor(entityOfCodeBlock, defaultValue, codeBlockInstance);
								return entityOfCodeBlock;
							} else {
								_led.throw.warning(_led.error.NOT_FOUND, uid, codeBlockName + ' inside CodeBlock');//No I18n
							}
						} else {
							const errorMessage = [
								_led.error.EXPECTED('string', typeof uid, 'uid'),//No I18n
								_led.error.EXPECTED('string', typeof codeBlockName, 'codeBlockName'), //No I18n
								_led.error.EXPECTED('object (or) string', typeof options, 'options') //No I18n
							].join('\n');//No I18n
							_led.throw.error(errorMessage);
						}
					}
				};
				/**
				 * Will create and load the model
		 		 * @param {String} uid 
				 * @param {String} codeBlockName Code block label
				 * @param {Object} options Options for Code block
				 * @param {String} defaultValue Default values
				 * @returns 
				 */
				const createAndLoad = function (uid, codeBlockName, options, defaultValue) {
					const entityOfCodeBlock = API.create(uid, codeBlockName, options);
					createdCodeBlocks.push(entityOfCodeBlock);
					API.load(entityOfCodeBlock, null, null, defaultValue);
					return entityOfCodeBlock;
				};
				/**
				 * Will give the mutable values object
				 * @returns Object
				 */
				const getCurrentMutableValues = function () {
					const uri = this.basedOnTypeGet('modelInstance').uri;//No I18n
					const uriMapping = _led.codeBlock.getCodeBlockEntity(uri);
					const id = uriMapping.id;
					const codeBlockName = uriMapping.codeBlockName;
					if (id && codeBlockName) {
						return _led.codeBlock[codeBlockName].createdEntities[id].getMutableValues();
					}
					return {};
				};
				/**
				 * Returns the current code block object
				 * @returns Object
				 */
				const getCurrentCodeBlock = function () {
					const uri = this.basedOnTypeGet('modelInstance').uri;//No I18n
					const uriMapping = _led.codeBlock.getCodeBlockEntity(uri);
					const id = uriMapping.id;
					const codeBlockName = uriMapping.codeBlockName;
					if (id && codeBlockName) {
						return _led.codeBlock[codeBlockName].createdEntities[id];
					}
					return {};
				}
				const disposeUtil = function () {
					if (!API.preventDisposalOfCodeBlocks) {
						createdCodeBlocks.forEach(function (codeBlock) {
							const instanceName = codeBlock.instanceName;
							const id = codeBlock.id;
							_led.codeBlock[instanceName].delete(id);
						});
					}
				}
				/**
				 * Creates range restrictions in the model
				 * @param {String} content String content for the model
				 * @param {Object} options Options for the Monaco editor modal
				 * @param {Array} rangeRestrictions Array of restriction objects	
				 * @returns Object
				 */
				const createModelWithRangeRestriction = function (content, options, rangeRestrictions) {
					const model = this.$node.createModel(content, options);
					if (model) {
						const monaco = this.data.monaco;
						const rangeConstructor = monaco.Range;
						return _led.restrictedEditor.addRangeRestrictionsTo(model, rangeRestrictions, rangeConstructor);
					}
					return null;
				}
				/**
				 * Updates range restrictions in the model
				 * @param {Object} model Monaco Model
				 * @param {Array} rangeRestrictions 
				 * @returns Object
				 */
				const updateRangeRestrictionsTo = function (model, rangeRestrictions) {
					if (model) {
						return _led.restrictedEditor.updateRangeRestrictionsTo(model, rangeRestrictions);
					}
					return null;
				}
				const methods = {
					create,
					load,
					createAndLoad,
					getCurrentMutableValues,
					getCurrentCodeBlock,
					disposeUtil,
					createModelWithRangeRestriction,
					updateRangeRestrictionsTo,
					preventDisposalOfCodeBlocks: false
				}
				const API = {};
				for (let method in methods) {
					if (type.function(methods[method])) {
						API[method] = methods[method].bind(this);
					} else {
						API[method] = methods[method];
					}
				}
				return API;
			}.call(this)),
			/**
			 * Updates Editor layout, This has to be done when the editor is 
			 * loaded asynchronously and if the wrapper div has a variable size
			 * 
			 * Sometimes, the editor will be loaded but the height of the
			 * editor will be 0px, at that time this function has to be called
			 */
			updateEditorLayout: function () {
				_led.updateEditorLayout(this);
				const haveToolbar = this.data.ltPropRenderScopedToolbar;
				if( haveToolbar ){
					const leNav = this.$node.querySelector("lyte-editor-toolbar lyte-nav");
					if(leNav){
					   leNav.recalculate();
					}
				}
			},
			/**
			 *To add decorations to editor
			 */
			addDecorations : function( decorations, isCustomised ){
				const editor = this.data.editorInstance,
				monaco = this.data.monaco;
				let decorationsToMoanco = [];
				if( isCustomised ){
					for( let i = 0; i < decorations.length; i++){
						let decoration = decorations[ i ],
						lines = decoration.lines,
						isWholeLine = decoration.options.isWholeLine;
						if( isWholeLine ){
							let j = 0,
							startLineNumber = lines[ j ],
							endLineNumber = lines[ j ]
							while( j < lines.length ){
								if( lines[ j ] + 1 === lines[ j + 1] ){
									endLineNumber = lines[ j + 1];
								}else{
									decorationsToMoanco.push( {
										range : new monaco.Range( endLineNumber, 0, startLineNumber, 0 ),
										options : decoration.options
									})
									startLineNumber = lines[ j + 1 ];
									endLineNumber = lines [ j + 1];
								}
								j++;
							}
						}else{
							let j = 0;
							while( j < lines.length){
								decorationsToMoanco.push( {
									range : lines[ j ],
									options : decoration.options
								})
								j++;
							}
						}
	
					}
				}else{
					decorationsToMoanco = decorations;
				}
				editor.createDecorationsCollection(decorationsToMoanco);
			}.bind(this),
			/**
			 * Actions means, custom keyboard shortcuts
			 * For some key combinations custom actions can be binded for the 
			 * editor
			 * 
			 * This Utils can be used for that purpose
			 */
			editorActions: (function () {
				const type = _led.checkType;
				const editorActionHandler = _led.editorActions;
				let listOfCallbacks = [];
				const addAction = function (callbackFn, editorType) {
					if (type.function(callbackFn)) {
						const monaco = this.data.monaco;
						if (editorType === undefined) {
							const EditorTypes = Lyte.Editor.EDITOR_TYPES
							const editorInstance = this.data.editorInstance;
							const diffEditorInstance = this.data.diffEditorInstance;
							if (editorInstance) {
								editorActionHandler.extend(callbackFn, monaco, editorInstance);
							} else {
								listOfCallbacks.push({
									callbackFn: callbackFn,
									editorType: EditorTypes.BASIC_EDITOR
								});
							}
							if (diffEditorInstance) {
								editorActionHandler.extend(callbackFn, monaco, diffEditorInstance);
							} else {
								listOfCallbacks.push({
									callbackFn: callbackFn,
									editorType: EditorTypes.DIFF_EDITOR
								});
							}
						} else if (_led.MONACO_SRC_LOADED && instance) {
							const instance = this.basedOnTypeGet('instance', editorType);//No I18n
							editorActionHandler.extend(callbackFn, monaco, instance);
							return true;
						} else {
							listOfCallbacks.push({
								callbackFn: callbackFn,
								editorType: editorType || null
							});
							return true;
						}
					} else {
						_led.throw.error(_led.error.TYPE_MUST_BE, 'function', 'callbackFn');//No I18n
						return false;
					}
				}
				const extendAllCallbacks = function (monaco, instance, loadedEditorType) {
					for (let i = 0, len = listOfCallbacks.length; i < len; i++) {
						const object = listOfCallbacks[i];
						const callbackFn = object.callbackFn;
						const editorType = object.editorType;
						if (loadedEditorType === editorType || editorType === null) {
							editorActionHandler.extend(callbackFn, monaco, instance);
							if (editorType !== null) {
								listOfCallbacks[i] = null;
							}
						}
					}
					listOfCallbacks = listOfCallbacks.filter(type.object);
				}

				const methods = {
					_extendAllCallbacks: extendAllCallbacks.bind(this),
					add: addAction,
					dispose: editorActionHandler.dispose,
					disposeAll: editorActionHandler.disposeAll,
					list: editorActionHandler.list
				}
				const API = {};
				for (let method in methods) {
					if (type.function(methods[method])) {
						API[method] = methods[method].bind(this);
					} else {
						API[method] = methods[method];
					}
				}
				return API;
			}.call(this)),
			/**
			 * Updates Compiler options for the languages
			 * @param {Object} compilerOptions 
			 */
			updateCompilerOptions: function (compilerOptions) {
				const monaco = this.data.monaco;
				if (monaco) {
					this.setCompilerOptions(monaco, compilerOptions);
				} else {
					_led.throw.warning('Monaco Editor is not available. Please call this function after (or) inside editor-core-loaded event');//No I18n
				}
			},
			/**
			 * Extracts the current theme from the internal variables of monaco
			 * @returns String
			 */
			getCurrentTheme: function () {
				const instance = this.basedOnTypeGet('instance');//No I18n
				return instance._themeService.getColorTheme().themeName;
			},
			createModel: function (content, options) {
				if (_led.MONACO_SRC_LOADED) {
					const monaco = this.data.monaco;
					options = options || {};
					const language = options.language;
					const uri = options.uri;
					const path = options.path;
					const actualUri = uri ? uri : path ? new monaco.Uri('', '', path) : undefined;
					return monaco.editor.createModel(content, language, actualUri);
				} else {
					_led.throw.warning('Monaco Editor is not available. Please call this function after (or) inside editor-core-loaded event');//No I18n
					return null;
				}
			},
			setBasicEditorModel: function (model, options={}) {
				const editorType = this.data.ltPropEditorType;
				if (editorType === Lyte.Editor.EDITOR_TYPES.BASIC_EDITOR) {
					const instance = this.basedOnTypeGet('instance');//No I18n
					if (instance) {
						if( this.data.ltPropPlaceholder ){
							if( model.getValue() !== "" ){
								this.hidePlaceholder();
							}
						}
						
						!options.preventModelCreation && this.setData('valueLoadedFromModel', true);
						instance.setModel(model);
						
					} else {
						_led.throw.warning('EditorInstance is not available. Please call this function inside `onBasicEditorLoad` method');//No I18n
						return null;
					}
				} else {
					_led.throw.warning('Current Editor Type is not a Basic Editor');//No I18n
				}
			},
			setDiffEditorModel : function( originalDiffModel, modifiedDiffModel){
				const editorType = this.data.ltPropEditorType;
				if (editorType === Lyte.Editor.EDITOR_TYPES.DIFF_EDITOR) {
					const instance = this.basedOnTypeGet('instance');//No I18n
					if (instance) {
						if( this.data.ltPropPlaceholder ){
							if( modifiedDiffModel.getValue() !== "" ){
								this.hidePlaceholder();
							}
						}
						instance.setModel({
							original: originalDiffModel,
							modified: modifiedDiffModel
						});
					} else {
						_led.throw.warning('EditorInstance is not available. Please call this function inside `onDiffEditorLoad` method');//No I18n
						return null;
					}
				} else {
					_led.throw.warning('Current Editor Type is not a Diff Editor');//No I18n
				}
			},
			closeMarkersNavigation: function () {
				const editorInstance = this.basedOnTypeGet('instance');//No I18n
				if (editorInstance) {
					// Reference https://github.com/microsoft/monaco-editor/issues/2688#issuecomment-937897937
					editorInstance.trigger('id', 'closeMarkersNavigation', {});//No I18n
				}
			},
			getFileExplorerData : function()
			{
				const editorComp = this;
				const fileExplorerData = editorComp.folder.getRootDirectory();
				return editorComp.directory.generateFileExplorerData(fileExplorerData).children;
			},
			refresh : function() {
				const editorComp = this;
				const fileItems = editorComp.directory.getDirectoryList();
				this.pubsub.fire("REFRESH_FILE_LIST", fileItems);
			},
			rename : function(path, newName, errorCallback) {
				this.pubsub.fire("RENAME_DIR", path, newName, errorCallback);
			},
			save : function(path) {
				const file = this.folder.getDirByPath(path);
				const needKeys = ["name","value","lastSavedValue","ext","isDirty","uniqueId"];
				this.saveDirectoryFile(file, needKeys);
			},
			close : function(uniqueId) {
				this.pubsub.fire("CLOSE_FILE", uniqueId);
			},
			createFile : function(name, fileContent, path, errorCallback, restrictActive) {
				const editorPanel = this.$node.querySelector("lyte-editor-directory-panel");
				return editorPanel.component.createDirectoryByPathName(name, "file", fileContent, path, errorCallback, restrictActive);
			},
			newFileInput : function() {
				const editorPanel = this.$node.querySelector("lyte-editor-directory-panel");
				editorPanel.component.genericFileCreator("file");
			}
		}
		if(this.data.ltPropShowLeftPanel){
			const leftPanelActive = function(path){
				const file = this.folder.getDirByPath(path);
				const id = file.uniqueId;
				// this.directory.openFile(id); //No I18n
				const node = this.$node.querySelector(`[unique-id=${id}`)
				node.closest('lyte-editor-directory-panel-item').component.fileActivation(id,"highLight",node);//No I18n
				this.setData("tbActiveItem",id);//No I18n
			}.bind(this);
			utils.leftPanel = {
				setActive : leftPanelActive
			}
			// utils.leftPanel.setActive = function(path){
			// 	const file = this.directory.getDirByPath(path);
			// 	const id = file.uniqueId;

			// };
		}
		
		for (let util in utils) {
			if (_led.checkType.function(utils[util])) {
				this.$node[util] = utils[util].bind(this);
			} else {
				this.$node[util] = utils[util];
			}
		}
		this.disposeUtils = function () {
			for (let utilName in utils) {
				if (this.$node[utilName].disposeUtil) {
					this.$node[utilName].disposeUtil();
				}
				delete this.$node[utilName];
			}
		}
	}.on('init')
});